(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (() => {
    // Rebuild marker for Shopify compiled section script bundle.
    const cartSection = document.querySelector('.onix-cart-page');
    if (!cartSection) return;

    cartSection.addEventListener('click', (event) => {
      const decreaseButton = event.target.closest('[data-quantity-decrease]');
      const increaseButton = event.target.closest('[data-quantity-increase]');

      if (!decreaseButton && !increaseButton) return;

      const control = event.target.closest('.onix-cart-page__quantity-control');
      if (!control) return;

      const input = control.querySelector('.onix-cart-page__quantity-input');
      if (!input) return;

      const currentValue = Number(input.value) || 0;
      const nextValue = decreaseButton ? Math.max(0, currentValue - 1) : currentValue + 1;
      input.value = String(nextValue);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* « Voir plus » : charge la page suivante en place (la <nav> pagination
     reste en fallback no-JS et se masque dès que le JS s'initialise).

     23/08 — le bouton restait grisé POUR TOUJOURS et le client bloqué à 30
     produits sur 702. Une réponse 200 SANS grille — ce que Shopify sert
     pendant un pic — tombait quand même dans le .then(), n'avait pas de
     [data-onix-more] à lire, partait donc dans la branche « il n'y a plus
     rien » et ne relâchait jamais btn.disabled. Le `hidden` posé là sur
     .onix-collection__more-wrap était en plus neutralisé par son
     display:flex : bouton toujours visible, grisé, curseur « chargement ».

     ➜ Le chemin a maintenant TROIS sorties nommées, et chacune relâche le
     bouton ou le retire. Surtout : une réponse inexploitable est un ÉCHEC,
     jamais une fin de liste — les confondre, c'est ce qui arrêtait le client
     à 30 maillots en lui faisant croire qu'il n'y en avait pas d'autres. */
  (function () {
    var btn = document.querySelector('[data-onix-more]');
    if (!btn) return;
    var grid = document.querySelector('[data-onix-grid]');
    var wrap = btn.closest('.onix-collection__more-wrap');
    var statut = wrap ? wrap.querySelector('[data-onix-more-statut]') : null;
    var nav = document.querySelector('.onix-collection__pagination');
    if (nav) nav.hidden = true;

    function dire(texte) {
      if (!statut) return;
      statut.hidden = !texte;
      statut.textContent = texte || '';
    }

    /* SORTIE 1 — épuisé : plus aucune page à charger. Le bouton QUITTE le DOM
       plutôt que de recevoir un `hidden` : sur ce conteneur en display:flex,
       un `hidden` ne masque rien (c'est le défaut du 23/08). */
    function epuise() {
      btn.remove();
      dire(wrap ? wrap.getAttribute('data-onix-fin') : '');
    }

    /* SORTIE 2 — échec : on relâche, on l'explique, et on REDONNE les numéros
       de page. Sans ce recours, un client tombé sur une réponse vide n'a plus
       aucun moyen d'atteindre les maillots suivants. */
    function echoue() {
      btn.disabled = false;
      dire(wrap ? wrap.getAttribute('data-onix-echec') : '');
      if (nav) nav.hidden = false;
    }

    /* SORTIE 3 — succès : on mémorise la page d'après et on rend le bouton. */
    function reussit(urlSuivante) {
      btn.setAttribute('data-onix-more', urlSuivante);
      btn.disabled = false;
      dire('');
    }

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-onix-more');
      if (btn.disabled || !url || !grid) return;
      btn.disabled = true;
      dire('');

      /* Une requête qui ne répond JAMAIS est, elle aussi, une sortie qui ne
         relâche jamais : on la borne pour que le bouton revienne dans tous
         les cas, y compris quand le réseau reste pendu sans erreur. */
      var arret = new AbortController();
      var minuteur = setTimeout(function () { arret.abort(); }, 15000);

      fetch(url, { signal: arret.signal })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grilleRecue = doc.querySelector('[data-onix-grid]');
          if (!grilleRecue) throw new Error('reponse sans grille');

          doc.querySelectorAll('[data-onix-grid] > *').forEach(function (c) {
            /* Le bloc « collection vide » n'est pas une carte produit : le
               recopier collerait un « cette collection est vide » au milieu
               des maillots déjà chargés. */
            if (c.classList.contains('onix-collection__empty')) return;
            grid.appendChild(document.importNode(c, true));
          });

          var suivant = doc.querySelector('[data-onix-more]');
          var urlSuivante = suivant && suivant.getAttribute('data-onix-more');
          if (urlSuivante) { reussit(urlSuivante); } else { epuise(); }
        })
        .catch(function () { echoue(); })
        .then(function () { clearTimeout(minuteur); });
    });
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function() {
  /* ── Footer accordéon : mobile = un seul ouvert, desktop = tous ouverts ── */
  var footer = document.querySelector('.onix-ft');
  var loadingText = footer ? footer.dataset.loadingText : '';
  var unavailableText = footer ? footer.dataset.unavailableText : '';
  var errorText = footer ? footer.dataset.errorText : '';

  /* Accordion behaviour — same on mobile and desktop:
       - all sections are folded by default
       - clicking a section opens it AND closes any other open one
     The native <details> click gesture handles open/close itself; we
     just wire up the "single-open" rule via the toggle event. */
  if (footer) {
    footer.addEventListener('toggle', function(e) {
      if (!e.target.classList.contains('onix-ft__col')) return;
      if (!e.target.open) return; /* a close event — nothing to do */
      footer.querySelectorAll('.onix-ft__col[open]').forEach(function(d) {
        if (d !== e.target) d.removeAttribute('open');
      });
    }, true);
  }

  var POPUP_ID = 'onix-policy-popup';

  /* Dans le contenu fetché de la policy contact-information, remplace les
     libellés texte (Email / Instagram / TikTok) par des icônes, garde la
     valeur cliquable, et remplace l'emoji du titre par une icône. */
  function iconifyContacts(root) {
    if (!root) return;
    var IG = 'https://www.instagram.com/onixm.fr';
    var TT = 'https://www.tiktok.com/@onixm.fr';
    var SC = 'https://www.snapchat.com/add/onixmfr';
    var IC = {
      phone: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L16 13l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 5a2 2 0 0 1 2-1z"/></svg>',
      email: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>',
      instagram: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="3.8"/><circle cx="17.3" cy="6.7" r="1.1" fill="currentColor" stroke="none"/></svg>',
      tiktok: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64c.3 0 .59.05.88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.04-.1z"/></svg>',
      snapchat: '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.206.793c.99 0 4.347.276 5.93 3.821.529 1.193.403 3.219.299 4.847l-.003.06c-.012.18-.022.345-.03.51.075.045.203.09.401.09.3-.016.659-.12 1.033-.301.165-.088.344-.104.464-.104.182 0 .359.029.509.09.45.149.734.479.734.838.015.449-.39.839-1.213 1.168-.089.029-.209.075-.344.119-.45.135-1.139.36-1.333.81-.09.224-.061.524.12.868l.015.015c.06.136 1.526 3.475 4.791 4.014.255.044.435.27.42.509 0 .075-.015.149-.045.225-.24.569-1.273.988-3.146 1.271-.059.091-.12.375-.164.57-.029.179-.074.36-.134.553-.076.271-.27.405-.555.405h-.03c-.135 0-.313-.031-.538-.074-.36-.075-.765-.135-1.273-.135-.3 0-.599.015-.913.074-.6.104-1.123.464-1.723.884-.853.599-1.826 1.288-3.294 1.288-.06 0-.119-.015-.18-.015h-.149c-1.468 0-2.427-.675-3.279-1.288-.599-.42-1.107-.779-1.707-.884-.314-.045-.629-.074-.928-.074-.54 0-.958.089-1.272.149-.211.043-.391.074-.54.074-.374 0-.523-.224-.583-.42-.061-.192-.09-.389-.135-.567-.046-.181-.105-.494-.166-.57-1.918-.222-2.95-.642-3.189-1.226-.031-.063-.052-.15-.055-.225-.015-.243.165-.465.42-.509 3.264-.54 4.73-3.879 4.791-4.02l.016-.029c.18-.345.224-.645.119-.869-.195-.434-.884-.658-1.332-.809-.121-.029-.24-.074-.346-.119-1.107-.435-1.257-.93-1.197-1.273.09-.479.674-.793 1.168-.793.146 0 .27.029.383.074.42.194.789.3 1.104.3.234 0 .384-.06.465-.105l-.046-.569c-.098-1.626-.225-3.651.307-4.837C7.392 1.077 10.739.807 11.727.807l.419-.015h.06z"/></svg>'
    };
    /* Titre « 📞 Coordonnées » → icône + texte. */
    [].forEach.call(root.querySelectorAll('h1, h2, h3'), function (h) {
      var t = h.textContent || '';
      if (!/coordonn|contact|kontakt|contát|contatt/i.test(t)) return;
      if (h.querySelector('.onix-contact-tic')) return;
      h.innerHTML = h.innerHTML.replace(/[☎✆📞📱✉️]/gu, '').trim();
      var ic = document.createElement('span');
      ic.className = 'onix-contact-tic';
      ic.innerHTML = IC.phone;
      h.insertBefore(ic, h.firstChild);
    });
    /* Ligne Email → icône + valeur. Réseaux (Instagram / TikTok / Snapchat)
       regroupés sur UNE SEULE ligne — Snapchat toujours affiché, même si la
       policy admin ne le liste pas encore. */
    var socialEls = [];
    var socialVals = {};
    [].forEach.call(root.querySelectorAll('p, li'), function (el) {
      if (el.querySelector('.onix-contact-ico') || el.classList.contains('onix-contact-socials')) return;
      var txt = (el.textContent || '').trim();
      if (/^\s*e-?mail\s*:/i.test(txt)) {
        var val = txt.replace(/^[^:]*:\s*/, '').trim();
        if (!val) return;
        el.classList.add('onix-contact-row');
        el.removeAttribute('style');
        el.innerHTML = '<span class="onix-contact-ico">' + IC.email + '</span><a class="onix-contact-val" href="mailto:' + val + '">' + val + '</a>';
        return;
      }
      var type = null;
      if (/^\s*instagram\s*:/i.test(txt)) type = 'instagram';
      else if (/^\s*tik\s*tok\s*:/i.test(txt)) type = 'tiktok';
      else if (/^\s*snap\s*chat\s*:/i.test(txt)) type = 'snapchat';
      if (!type) return;
      socialEls.push(el);
      var v = txt.replace(/^[^:]*:\s*/, '').trim();
      if (v) socialVals[type] = v;
    });
    if (socialEls.length) {
      var NETS = [
        ['instagram', IG, socialVals.instagram || 'onixm.fr'],
        ['tiktok', TT, socialVals.tiktok || 'onixm.fr'],
        ['snapchat', SC, socialVals.snapchat || 'onixmfr']
      ];
      var row = document.createElement('p');
      row.className = 'onix-contact-socials';
      row.innerHTML = NETS.map(function (n) {
        return '<a class="onix-contact-soc" href="' + n[1] + '" target="_blank" rel="noopener"><span class="onix-contact-ico">' + IC[n[0]] + '</span><span class="onix-contact-val">' + n[2] + '</span></a>';
      }).join('');
      socialEls[0].parentNode.insertBefore(row, socialEls[0]);
      socialEls.forEach(function (el) { el.remove(); });
    }
  }

  function removePopup() {
    var el = document.getElementById(POPUP_ID);
    if (el) el.remove();
    document.body.style.overflow = '';
  }

  function showPolicy(url, title) {
    removePopup();
    var overlay = document.createElement('div');
    overlay.id = POPUP_ID;
    overlay.style.cssText = 'position:fixed;inset:0;z-index:100010;display:flex;align-items:center;justify-content:center;background:rgba(0,0,0,0.6);backdrop-filter:blur(6px);animation:onix-pol-in 0.25s ease both';

    overlay.innerHTML =
      '<div style="background:rgba(10,10,12,0.38);backdrop-filter:blur(28px) saturate(1.4);-webkit-backdrop-filter:blur(28px) saturate(1.4);border:1px solid rgba(255,255,255,0.08);border-radius:1.25rem;width:min(92vw,40rem);max-height:85vh;display:grid;grid-template-rows:auto 1fr;position:relative;animation:onix-pol-scale 0.3s cubic-bezier(0.22,1,0.36,1) both;overflow:hidden;">' +
        '<div style="display:flex;align-items:center;justify-content:space-between;padding:1.2rem 1.5rem;border-bottom:1px solid rgba(255,255,255,0.08);">' +
          '<h2 style="margin:0;font-size:0.92rem;font-weight:700;text-transform:uppercase;letter-spacing:0.12em;color:#fff;">' + (title || '') + '</h2>' +
          '<button type="button" data-pol-close style="background:none;border:none;font-size:1.3rem;cursor:pointer;color:rgba(255,255,255,0.5);width:2rem;height:2rem;display:flex;align-items:center;justify-content:center;border-radius:50%;transition:color 180ms,background 180ms;">✕</button>' +
        '</div>' +
        '<div data-pol-body style="padding:1.5rem;overflow-y:auto;color:rgba(255,255,255,0.78);font-size:0.98rem;line-height:1.7;-webkit-overflow-scrolling:touch;">' +
          '<div style="display:flex;justify-content:center;padding:3rem 0;"><span style="color:rgba(255,255,255,0.3);">' + loadingText + '</span></div>' +
        '</div>' +
      '</div>';

    if (!document.getElementById('onix-pol-style')) {
      var s = document.createElement('style');
      s.id = 'onix-pol-style';
      s.textContent = '@keyframes onix-pol-in{from{opacity:0}to{opacity:1}}@keyframes onix-pol-scale{from{opacity:0;transform:scale(0.95)}to{opacity:1;transform:scale(1)}}#onix-policy-popup [data-pol-body] h1,#onix-policy-popup [data-pol-body] h2,#onix-policy-popup [data-pol-body] h3{color:#fff;margin:1.2rem 0 0.5rem;font-size:1.05rem;font-weight:700;letter-spacing:0.04em}#onix-policy-popup [data-pol-body] p{margin:0 0 0.8rem}#onix-policy-popup [data-pol-body] a{color:#00c8ff;text-decoration:underline}#onix-policy-popup [data-pol-body] ul,#onix-policy-popup [data-pol-body] ol{padding-left:1.2rem;margin:0 0 0.8rem}#onix-policy-popup [data-pol-close]:hover{color:#fff;background:rgba(255,255,255,0.1)}#onix-policy-popup [data-pol-body] .onix-contact-row{display:flex;align-items:center;gap:0.65rem;padding-left:0!important;margin:0 0 0.75rem}#onix-policy-popup [data-pol-body] .onix-contact-ico{display:inline-flex;width:1.35rem;height:1.35rem;flex-shrink:0;color:#00c8ff}#onix-policy-popup [data-pol-body] .onix-contact-ico svg{width:100%;height:100%}#onix-policy-popup [data-pol-body] .onix-contact-val{color:#fff;text-decoration:none;word-break:break-word}#onix-policy-popup [data-pol-body] .onix-contact-val:hover{color:#00c8ff;text-decoration:underline}#onix-policy-popup [data-pol-body] .onix-contact-tic{display:inline-flex;width:1.2rem;height:1.2rem;color:#00c8ff;vertical-align:-0.18rem;margin-right:0.45rem}#onix-policy-popup [data-pol-body] .onix-contact-tic svg{width:100%;height:100%}#onix-policy-popup [data-pol-body] .onix-contact-socials{display:flex;align-items:center;gap:0.9rem;flex-wrap:nowrap;margin:0 0 0.75rem;padding-left:0!important}#onix-policy-popup [data-pol-body] .onix-contact-soc{display:inline-flex;align-items:center;gap:0.45rem;text-decoration:none;white-space:nowrap;min-width:0}#onix-policy-popup [data-pol-body] .onix-contact-soc .onix-contact-val{font-size:0.94em}#onix-policy-popup [data-pol-body] .onix-contact-soc:hover .onix-contact-val{color:#00c8ff}';
      document.head.appendChild(s);
    }

    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';

    overlay.querySelector('[data-pol-close]').addEventListener('click', removePopup);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) removePopup(); });
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Escape') { removePopup(); document.removeEventListener('keydown', handler); }
    });

    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var selectors = ['.shopify-policy__body','.shopify-policy__container','section.shopify-policy','.policy-content','[data-policy-content]','main .rte','main .page-body','main article','main','.content-for-layout','#MainContent','#shopify-section-template--*'];
        var content = null;
        for (var si = 0; si < selectors.length; si++) {
          try { content = doc.querySelector(selectors[si]); } catch(e) {}
          if (content) break;
        }
        // Fallback : prendre le body entier
        if (!content) content = doc.body;
        var body = overlay.querySelector('[data-pol-body]');
        if (content) {
          var clone = content.cloneNode(true);
          // Supprimer tout ce qui n'est pas du contenu
          clone.querySelectorAll('script,style,link,meta,nav,header,footer,noscript,.header,.footer,.onix-ft,[data-cart-drawer-root],.shopify-section-header,.shopify-section-footer,#shopify-section-header,#shopify-section-footer,.announcement-bar,iframe').forEach(function(el){ el.remove(); });
          var html = clone.innerHTML.trim();
          // Si le HTML nettoyé est trop court, c'est un échec
          body.innerHTML = html.length > 30 ? html : '<p style="color:rgba(255,255,255,0.4);text-align:center;">' + unavailableText + '</p>';
          iconifyContacts(body);
        } else {
          body.innerHTML = '<p style="color:rgba(255,255,255,0.4);text-align:center;">' + unavailableText + '</p>';
        }
      })
      .catch(function() {
        var body = overlay.querySelector('[data-pol-body]');
        body.innerHTML = '<p style="color:rgba(255,255,255,0.4);text-align:center;">' + errorText + '</p>';
      });
  }

  document.addEventListener('click', function(e) {
    var link = e.target.closest('[data-policy-popup]');
    if (!link) {
      var a = e.target.closest('a[href*="/policies/"]');
      if (a) link = a;
    }
    if (!link) return;
    e.preventDefault();
    /* Si le clic vient du menu mobile ouvert, le fermer d'abord pour n'avoir
       qu'un seul overlay (le popup passe au premier plan via son z-index). */
    var mShell = document.querySelector('.onix-mobile-drawer-shell');
    if (mShell && !mShell.hasAttribute('inert')) {
      var mClose = document.querySelector('.onix-mobile-drawer-close');
      if (mClose) mClose.click();
    }
    showPolicy(link.href, link.textContent.trim());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* ── Banniere split-flap (tableau des departs) ── */
  (function () {
    var el = document.querySelector('[data-ann-flap]');
    if (!el || el.__flapInit) return;
    el.__flapInit = true;
    var raw = el.getAttribute('data-ann-msgs') || el.textContent || '';
    var msgs = raw.split('/').map(function (x) { return x.trim().toUpperCase(); }).filter(Boolean);
    if (!msgs.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function render(msg, animate) {
      el.textContent = '';
      var frag = document.createDocumentFragment();
      for (var i = 0; i < msg.length; i++) {
        var c = document.createElement('span');
        if (msg[i] === ' ') { c.className = 'fc sp'; c.textContent = '\u00a0'; }
        else { c.className = 'fc'; c.textContent = msg[i]; }
        frag.appendChild(c);
      }
      el.appendChild(frag);
      if (animate && !reduce) {
        var cells = el.querySelectorAll('.fc');
        for (var j = 0; j < cells.length; j++) {
          (function (cell, k) { setTimeout(function () { cell.classList.add('flip'); }, k * 38); })(cells[j], j);
        }
      }
    }
    var idx = 0;
    render(msgs[0], false);
    if (msgs.length > 1 && !reduce) {
      setInterval(function () { idx = (idx + 1) % msgs.length; render(msgs[idx], true); }, 3400);
    }
  })();

  (function () {
    var header = document.querySelector('.site-header');
    if (!header) return;

    /* Hauteur de la barre d'annonce pour le décalage */
    var annBar = header.querySelector('.header-ann');
    function getAnnBarHeight() {
      return annBar ? annBar.offsetHeight : 0;
    }

    /* Le header reste toujours à top: 0 — l'annonce est à l'intérieur */

    var mobileQuery = window.matchMedia('(max-width: 749px)');
    var burgerButton = header.querySelector('.onix-burger-button');
    var drawerShell = document.querySelector('.onix-mobile-drawer-shell');
    var drawer = document.querySelector('.onix-mobile-drawer');
    var drawerOverlay = document.querySelector('.onix-mobile-drawer-overlay');
    var drawerCloseButton = document.querySelector('.onix-mobile-drawer-close');
    var cartCount = header.querySelector('[data-cart-count]');
    var cartButton = header.querySelector('.header__cart-button');
    var lastCount = cartCount ? cartCount.textContent.trim() : '';
    var ticking = false;
    var lastScrollY = window.scrollY || 0;
    var lockedScrollY = 0;

    function lockPageScroll() {
      lockedScrollY = window.scrollY || 0;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.touchAction = 'none';
    }

    function unlockPageScroll() {
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      window.scrollTo(0, lockedScrollY);
    }

    function setMenuState(open) {
      document.body.classList.toggle('is-menu-open', open);

      if (open) {
        lockPageScroll();
      } else {
        unlockPageScroll();
      }

      if (drawerShell) {
        if (!open) {
          var activeElement = document.activeElement;
          if (activeElement instanceof HTMLElement && drawerShell.contains(activeElement)) {
            activeElement.blur();
          }

          if (burgerButton instanceof HTMLElement) {
            burgerButton.focus({ preventScroll: true });
          }
        }

        drawerShell.setAttribute('aria-hidden', open ? 'false' : 'true');
        drawerShell.inert = !open;
      }

      if (burgerButton) {
        burgerButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        burgerButton.setAttribute('aria-label', open ? burgerButton.dataset.labelClose : burgerButton.dataset.labelOpen);
      }
    }

    /* Est-ce que le header est en mode solid (pages non-homepage) ? */
    var isSolid = header.classList.contains('site-header--solid');

    function updateScrollState() {
      var currentScrollY = window.scrollY || 0;

      if (!mobileQuery.matches) {
        if (document.body.classList.contains('is-menu-open')) {
          setMenuState(false);
        }
      }

      var annHeight = getAnnBarHeight();

      /* ⚠️ RÉSERVER LA PLACE. En passant en `fixed`, le header quitte le flux :
         sans ça le contenu remonte de sa hauteur d'un coup. On fige la hauteur
         du conteneur au moment de la bascule, on la relâche au retour. */
      if (currentScrollY > annHeight + 20) {
        if (isSolid && !header.classList.contains('is-scrolled')) {
          var hote = header.parentElement && header.parentElement.parentElement;
          if (hote && hote.classList.contains('onix-header-overlay')) {
            hote.style.minHeight = Math.round(header.getBoundingClientRect().height) + 'px';
          }
        }
        header.classList.add('is-scrolled');

        if (currentScrollY > lastScrollY) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        if (isSolid) {
          var hote2 = header.parentElement && header.parentElement.parentElement;
          if (hote2 && hote2.classList.contains('onix-header-overlay')) hote2.style.minHeight = '';
        }
        header.classList.remove('is-scrolled');
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        updateScrollState();
        ticking = false;
      });
    }

    updateScrollState();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    mobileQuery.addEventListener('change', updateScrollState);

    if (burgerButton && drawer && drawerOverlay && drawerCloseButton && !burgerButton.dataset.bound) {
      burgerButton.dataset.bound = 'true';
      burgerButton.setAttribute('aria-expanded', 'false');

      burgerButton.addEventListener('click', function () {
        setMenuState(true);
      });

      drawerCloseButton.addEventListener('click', function () {
        setMenuState(false);
      });

      drawerOverlay.addEventListener('click', function () {
        setMenuState(false);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && document.body.classList.contains('is-menu-open')) {
          setMenuState(false);
        }
      });
    }

    if (cartCount && cartButton && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        var nextCount = cartCount.textContent.trim();
        if (nextCount == lastCount) return;
        lastCount = nextCount;
        cartButton.classList.remove('is-updated');
        requestAnimationFrame(function () {
          cartButton.classList.add('is-updated');
        });
        window.setTimeout(function () {
          cartButton.classList.remove('is-updated');
        }, 340);
      });

      observer.observe(cartCount, { childList: true, subtree: true, characterData: true });
    }
  })();

  /* ── Search Drawer ───────────────────────────────────── */
  (function () {
    var trigger  = document.getElementById('search-drawer-trigger');
    var drawer   = document.getElementById('search-drawer');
    var overlay  = document.getElementById('search-drawer-overlay');
    var closeBtn = document.getElementById('search-drawer-close');
    var input    = document.getElementById('search-drawer-input');
    var results  = document.getElementById('search-drawer-results');
    var list     = document.getElementById('search-drawer-list');
    var allLink  = document.getElementById('search-drawer-all');
    var allText  = document.getElementById('search-drawer-all-text');
    var teams    = document.getElementById('search-drawer-teams');

    if (!trigger || !drawer) return;

    var label  = document.getElementById('search-drawer-label');
    var timer = null;
    var lastQuery = '';

    /* Traductions depuis les data attributes */
    var i18nMostChosen = drawer.dataset.labelMostChosen || 'Best sellers';
    var i18nResults    = drawer.dataset.labelResults || 'Results';
    var i18nNoResults  = drawer.dataset.labelNoResults || 'No products found for "__QUERY__"';
    var i18nRepli      = drawer.dataset.labelRepli || '';
    var i18nSeeAll     = drawer.dataset.labelSeeAll || '';
    /* Le libellé d'origine du lien, relu UNE fois : c'est celui qu'on remet quand
       le lien repointe les best-sellers et non une recherche. */
    var i18nSeeAllDefaut = allText ? allText.textContent : '';

    /* L'ÉTAT D'OUVERTURE : les pastilles, PUIS six best-sellers. */
    var BEST_A_L_OUVERTURE = 6;

    /* LES 4 DU BLOC DU HAUT DE L'ACCUEIL NE SE REMONTRENT PAS — sa consigne :
       « sur la home page ça sert à rien d'afficher les 4 premiers parce qu'on les
       voyait déjà directement en premier sur la page ».
       ⚠️ QUATRE, PAS « TOUT CE QUI EST SUR LA PAGE ». J'ai d'abord lu la page
         ENTIÈRE : l'accueil porte 123 liens produit, dont les 12 premiers
         best-sellers, et le tiroir ouvrait sur les rangs 13, 15, 17, 20, 21.
         « pourquoi ici c'est pas les bons maillots ? » — c'était ça.
       ➜ On ne lit QUE le bloc numéroté du haut (`onix_top_bestsellers`), celui
         qu'il a en tête. Il n'existe que sur l'accueil : ailleurs, rien n'est
         écarté et le tiroir montre les six premiers.
       ⚠️ Le tiroir vit dans la section header ; ce sélecteur ne l'atteint pas,
         donc il ne peut pas s'exclure lui-même. */
    function handlesDuBlocDuHaut() {
      var vus = {};
      try {
        var bloc = document.querySelector('[id*="onix_top_bestsell"]');
        if (!bloc) return vus;
        bloc.querySelectorAll('a[href*="/products/"], [data-product-url]').forEach(function (e) {
          var v = e.getAttribute('href') || e.getAttribute('data-product-url') || '';
          var m = v.match(/\/products\/([a-z0-9-]+)/i);
          if (m) vus[m[1]] = 1;
        });
      } catch (e) {}
      return vus;
    }

    function montrerEquipes() {
      if (teams) teams.hidden = false;
      if (defaultLoaded) { renderDefaultResults(null, BEST_A_L_OUVERTURE); return; }
      /* Pas encore chargés : on n'affiche pas une boîte vide, elle arrivera. */
      results.hidden = true;
      list.innerHTML = '';
    }

    /* `formatMoney` a été retiré avec le prix : plus aucun montant ne s'affiche
       dans le tiroir. Il vit toujours ailleurs dans le thème pour le panier. */

    var defaultLoaded = false;
    var defaultCollectionUrl = drawer.dataset.defaultCollection || '/collections/les-meilleurs-maillots-1';

    function openDrawer() {
      drawer.classList.add('is-open');
      overlay.classList.add('is-visible');
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      if (input) setTimeout(function () { input.focus(); }, 320);
      /* Les best-sellers ne s'affichent plus à l'ouverture — les pastilles les
         remplacent. On les charge quand même en tâche de fond : ils servent de
         repli quand une recherche ne rend rien. */
      montrerEquipes();
      if (!defaultLoaded) loadDefaultSuggestions();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      if (input) input.value = '';
      lastQuery = '';
      montrerEquipes();
    }

    var defaultProducts = [];

    /* ── Recherche par INITIALES / acronymes d'équipes ──────────────
       Onix 2026-05-27 : la recherche native Shopify matche sur le
       titre/tags. « PSG », « RM », « FCB », « OM »… ne donnaient rien
       (ou des résultats parasites) car l'acronyme n'est pas dans le
       titre (« Real Madrid », « FC Barcelone »…). On mappe l'acronyme
       saisi → nom complet du club AVANT d'interroger Shopify.
       Clé = acronyme normalisé (minuscule, sans espace/point/tiret),
       donc « PSG », « psg », « P.S.G », « p s g » → même clé « psg ».
       Map construite à partir des clubs réellement présents au
       catalogue (extraction des 796 titres produits). */
    /* La VALEUR est le mot/groupe le plus DISTINCTIF présent dans les
       titres de l'équipe (maximise le rappel ; ex. « om » → « Marseille »
       couvre « Olympique de Marseille » ET « Marseille »). Couvre tout
       le catalogue : clubs (acronymes + surnoms) + noms anglais des
       sélections. Recherche déjà insensible aux accents côté Shopify. */
    var TEAM_ACRONYMS = {
      /* ── Ligue 1 ── */
      psg: 'Paris Saint Germain', om: 'Marseille', ol: 'Lyonnais', olympiquelyonnais: 'Lyonnais',
      asm: 'Monaco', asmonaco: 'Monaco', rcl: 'Lens', rclens: 'Lens', losc: 'Lille', lilleosc: 'Lille',
      fcn: 'Nantes', ogcn: 'Nice', asse: 'Saint-Étienne', sco: 'Angers', fcmetz: 'Metz', parisfc: 'Paris FC',
      /* ── Premier League ── */
      mu: 'Manchester United', mufc: 'Manchester United', manu: 'Manchester United', reddevils: 'Manchester United',
      mc: 'Manchester City', mcfc: 'Manchester City', mancity: 'Manchester City', citizens: 'Manchester City',
      lfc: 'Liverpool', reds: 'Liverpool', cfc: 'Chelsea', blues: 'Chelsea',
      afc: 'Arsenal', gunners: 'Arsenal', thfc: 'Tottenham', spurs: 'Tottenham',
      avfc: 'Aston Villa', wwfc: 'Wolverhampton', wolves: 'Wolverhampton',
      whu: 'West Ham', hammers: 'West Ham', nufc: 'Newcastle', magpies: 'Newcastle',
      efc: 'Everton', toffees: 'Everton', cpfc: 'Crystal Palace', lufc: 'Leeds', itfc: 'Ipswich',
      bha: 'Brighton', brighton: 'Brighton',
      /* ── La Liga ── */
      rm: 'Real Madrid', rmcf: 'Real Madrid', merengue: 'Real Madrid', losblancos: 'Real Madrid',
      fcb: 'Barcelone', barca: 'Barcelone', barça: 'Barcelone', blaugrana: 'Barcelone', cule: 'Barcelone',
      atm: 'Atlético Madrid', atleti: 'Atlético Madrid', colchoneros: 'Atlético Madrid',
      betis: 'Real Betis', realbetis: 'Real Betis', vcf: 'Valencia', valencia: 'Valencia',
      realsociedad: 'Real Sociedad', sociedad: 'Real Sociedad', athletic: 'Athletic Bilbao', bilbao: 'Athletic Bilbao',
      sevilla: 'Séville', seville: 'Séville', villarreal: 'Villarreal', girona: 'Girona', celta: 'Celta Vigo',
      mallorca: 'Mallorca', elche: 'Elche', laspalmas: 'Las Palmas', levante: 'Levante', tenerife: 'Tenerife', malaga: 'Málaga',
      /* ── Serie A ── */
      acm: 'AC Milan', milanac: 'AC Milan', rossoneri: 'AC Milan',
      fcim: 'Inter Milan', internazionale: 'Inter Milan', nerazzurri: 'Inter Milan',
      juve: 'Juventus', bianconeri: 'Juventus', asr: 'AS Roma', giallorossi: 'AS Roma',
      ssc: 'Napoli', sscnapoli: 'Napoli', lazio: 'Lazio', fiorentina: 'Fiorentina', viola: 'Fiorentina',
      atalanta: 'Atalanta', bologna: 'Bologne', parma: 'Parma', venezia: 'Venezia', venice: 'Venezia',
      palermo: 'Palerme', atleticomineiro: 'Atlético Mineiro',
      /* ── Bundesliga ── */
      bvb: 'Borussia Dortmund', dortmund: 'Borussia Dortmund',
      fcbayern: 'Bayern', bayern: 'Bayern', bayernmunich: 'Bayern',
      b04: 'Leverkusen', leverkusen: 'Leverkusen', rbl: 'RB Leipzig', leipzig: 'RB Leipzig',
      bmg: 'Mönchengladbach', gladbach: 'Mönchengladbach', stpauli: 'St. Pauli', werder: 'Werder Bremen',
      koln: 'Köln', cologne: 'Köln', hertha: 'Hertha', wolfsburg: 'Wolfsburg', dusseldorf: 'Düsseldorf', stuttgart: 'Stuttgart',
      /* ── Portugal ── */
      slb: 'Benfica', benfica: 'Benfica', fcp: 'Porto', porto: 'Porto',
      scp: 'Sporting', sporting: 'Sporting', braga: 'Braga',
      /* ── Autres championnats / clubs ── */
      gs: 'Galatasaray', gala: 'Galatasaray', fener: 'Fenerbahçe', fenerbahce: 'Fenerbahçe',
      bjk: 'Beşiktaş', besiktas: 'Beşiktaş', ajax: 'Ajax', psv: 'PSV', psveindhoven: 'PSV',
      celtic: 'Celtic', rangers: 'Rangers', panathinaikos: 'Panathinaikos', pao: 'Panathinaikos',
      etoilerouge: 'Étoile Rouge', redstar: 'Étoile Rouge',
      /* Amériques */
      intermiami: 'Inter Miami', miamicf: 'Inter Miami', boca: 'Boca Juniors', bocajuniors: 'Boca Juniors',
      river: 'River Plate', riverplate: 'River Plate', flamengo: 'Flamengo', botafogo: 'Botafogo',
      corinthians: 'Corinthians', santos: 'Santos', vasco: 'Vasco da Gama', cruzeiro: 'Cruzeiro', mineiro: 'Atlético Mineiro',
      america: 'América', clubamerica: 'América', monterrey: 'Monterrey', pumas: 'Pumas', unam: 'Pumas',
      lafc: 'Los Angeles', losangeles: 'Los Angeles', nycfc: 'New York City', newyorkcity: 'New York City',
      redbulls: 'New York Red Bulls', philadelphia: 'Philadelphia',
      /* Moyen-Orient */
      alnassr: 'Al Nassr', alhilal: 'Al Hilal',
      /* ── Sélections nationales — noms ANGLAIS → FR (les accents sont
         déjà gérés ; ces alias couvrent les visiteurs anglophones) ── */
      germany: 'Allemagne', spain: 'Espagne', brazil: 'Brésil', england: 'Angleterre',
      netherlands: 'Pays-Bas', holland: 'Pays-Bas', belgium: 'Belgique', italy: 'Italie',
      japan: 'Japon', argentina: 'Argentine', mexico: 'Mexique', morocco: 'Maroc',
      algeria: 'Algérie', tunisia: 'Tunisie', egypt: 'Égypte', cameroon: 'Cameroun',
      /* ⚠️ « ivoire » seul rendait ZÉRO — mesuré le 15/08 sur suggest.json.
         Ce n'est PAS un problème d'accent : « bresil », « senegal », « egypte »,
         « koln », « besiktas » passent tous, Shopify replie les accents. C'est
         l'APOSTROPHE : le titre dit « Côte d’Ivoire », Shopify indexe « d’ivoire »
         d'un bloc, et « ivoire » ne commence aucun mot. « cote » marche, « ivoire »
         non — et c'est « ivoire » que le client tape.
         ⚠️ Ces clés ne sont PAS dans MIDPHRASE_SAFE, donc elles ne s'étendent que
           si la requête ENTIÈRE vaut la clé : « Blanc Ivoire » est une couleur, on
           ne va pas la transformer en pays au milieu d'une phrase. */
      ivoire: 'Côte d’Ivoire', ivoirien: 'Côte d’Ivoire', ivoirienne: 'Côte d’Ivoire',
      cotedivoire: 'Côte d’Ivoire',
      ivorycoast: 'Côte d’Ivoire', colombia: 'Colombie', croatia: 'Croatie', scotland: 'Écosse',
      ireland: 'Irlande', wales: 'Galles', switzerland: 'Suisse', norway: 'Norvège',
      chile: 'Chili', ecuador: 'Équateur', southkorea: 'Corée du Sud', korea: 'Corée du Sud',
      saudiarabia: 'Arabie Saoudite', jordan: 'Jordanie', jamaica: 'Jamaïque', haiti: 'Haïti',
      finland: 'Finlande', albania: 'Albanie', portugal: 'Portugal', senegal: 'Sénégal',
      /* ── Compétitions / éditions (le titre dit « LDC ») ── */
      ucl: 'LDC', c1: 'LDC', ldc: 'LDC', championsleague: 'LDC', liguedeschampions: 'LDC'
    };
    /* Initiales PURES sûres à étendre en MILIEU de phrase (« psg ldc »
       → « Paris Saint Germain LDC »). Les autres clés (noms/surnoms-mots)
       ne s'étendent QUE si la requête entière = la clé, pour ne jamais
       sur-étendre (« inter miami » reste « inter miami »). */
    var MIDPHRASE_SAFE = {
      psg:1, om:1, ol:1, rm:1, rmcf:1, fcb:1, mu:1, mufc:1, mc:1, mcfc:1, lfc:1, cfc:1,
      afc:1, thfc:1, avfc:1, wwfc:1, whu:1, nufc:1, efc:1, cpfc:1, lufc:1, itfc:1, bha:1,
      atm:1, vcf:1, asm:1, rcl:1, losc:1, fcn:1, ogcn:1, asse:1, sco:1,
      acm:1, fcim:1, asr:1, ssc:1, bvb:1, b04:1, rbl:1, bmg:1, slb:1, fcp:1, scp:1,
      gs:1, bjk:1, psv:1, pao:1, lafc:1, nycfc:1,
      ucl:1, c1:1, ldc:1, championsleague:1, liguedeschampions:1
    };
    /* ⚠️ LES ACCENTS SE REPLIENT ICI. Avant, la clé les gardait : « côte
       d'ivoire » donnait « côtedivoire » et « cote d'ivoire » « cotedivoire »,
       deux clés différentes pour la même équipe. Une seule des deux pouvait être
       dans la table. */
    function normKey(s) {
      return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-z0-9]/g, '');
    }
    /* Étend une requête vers le terme catalogue :
       1) requête ENTIÈRE = clé connue → terme distinctif (« psg » →
          « Paris Saint Germain », « gunners » → « Arsenal »).
       2) requête MULTI-mots : on étend seulement les tokens qui sont des
          INITIALES PURES (MIDPHRASE_SAFE), pour gérer « psg ldc » sans
          jamais sur-étendre un nom-mot. */
    function expandQuery(q) {
      var raw = String(q || '').trim();
      if (!raw) return q;
      var whole = normKey(raw);
      if (TEAM_ACRONYMS[whole]) return TEAM_ACRONYMS[whole];
      var parts = raw.split(/\s+/);
      if (parts.length < 2) return raw;
      var changed = false;
      var out = parts.map(function (tok) {
        var k = normKey(tok);
        if (TEAM_ACRONYMS[k] && MIDPHRASE_SAFE[k]) { changed = true; return TEAM_ACRONYMS[k]; }
        return tok;
      });
      return changed ? out.join(' ') : raw;
    }

    /* 12 : les 6 montrés, plus une petite marge. Il a fallu monter à 40 tant que
       la règle d'exclusion tournait — 172 ko pour en garder 6. La règle est
       partie, le poids aussi : ~50 ko, chargés une seule fois à la première
       ouverture du tiroir et pas au chargement de la page.
       ⚠️ PAS DE `sort_by` : mesuré le 15/08, products.json l'IGNORE — avec et sans
         `best-selling` il rend exactement le même ordre. Le laisser ferait croire
         à un tri qui n'a pas lieu. L'ordre est celui de la collection, refaite
         chaque jour à 5h12 par `scripts/collection-meilleures-ventes.js`. */
    function loadDefaultSuggestions() {
      fetch(defaultCollectionUrl + '/products.json?limit=12')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var raw = (data && data.products) || [];
          defaultProducts = raw.map(function (p) {
            var img = p.images && p.images[0] ? { url: p.images[0].src } : null;
            return { url: '/products/' + p.handle, handle: p.handle, title: p.title, featured_image: img };
          });
          defaultLoaded = true;
          /* ⚠️ ON N'AFFICHE QUE SI LE CHAMP EST ENCORE VIDE. Le chargement arrive
             ~200 ms après l'ouverture : s'il a déjà tapé, écrire ici écraserait
             ses résultats par des best-sellers. */
          if (!lastQuery) montrerEquipes();
        })
        .catch(function () {});
    }

    /* Création DOM sécurisée — pas de innerHTML avec des données externes.
       ⚠️ PLUS DE PRIX : 24,99 € sur 558 des 679 produits. Il répétait le même
         chiffre sous chaque vignette et prenait la place du titre. Le prix se lit
         sur la fiche, là où il y a une décision à prendre. */
    function buildProductItem(p, imgUrl) {
      var li = document.createElement('li');
      li.className = 'search-drawer__item';
      var a = document.createElement('a');
      a.href = p.url;

      var imgDiv = document.createElement('div');
      imgDiv.className = 'search-drawer__img';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl + (imgUrl.indexOf('?') > -1 ? '&' : '?') + 'width=300';
        img.alt = p.title || '';
        img.loading = 'lazy';
        imgDiv.appendChild(img);
      }

      /* On ne découpe PAS le titre ici. `data-onix-title` + une classe qui finit
         par `__name`, et le snippet onix-card-title fait le reste : même découpage
         ÉQUIPE / MODÈLE que les cartes produit, et même repli en sigle quand la
         ligne déborde. Le texte brut reste posé en secours si le snippet manque. */
      var name = document.createElement('span');
      name.className = 'search-drawer__name';
      name.setAttribute('data-onix-title', p.title || '');
      name.textContent = p.title || '';

      a.appendChild(imgDiv);
      a.appendChild(name);
      li.appendChild(a);
      return li;
    }

    /* Les best-sellers ne s'affichent plus à l'ouverture : ils servent de REPLI
       quand une requête ne rend rien. Un cul-de-sac (« aucun produit trouvé ») est
       la pire fin de course — 62 recherches par mois y tombaient. */
    function renderDefaultResults(query, limite) {
      if (!defaultProducts.length) return false;
      var n = limite || defaultProducts.length;
      if (label) {
        label.textContent = (query && i18nRepli)
          ? i18nRepli.replace('__QUERY__', '« ' + query + ' »')
          : i18nMostChosen;
      }

      var vus = handlesDuBlocDuHaut();
      var liste = defaultProducts.filter(function (p) { return !vus[p.handle]; });
      /* Filet : si l'écart laissait moins de six maillots, on reprend la liste
         entière plutôt que d'afficher une rangée trouée. */
      if (liste.length < n) liste = defaultProducts;

      list.innerHTML = '';
      liste.slice(0, n).forEach(function (p) {
        var imgUrl = (p.featured_image && p.featured_image.url) ? p.featured_image.url : '';
        list.appendChild(buildProductItem(p, imgUrl));
      });
      if (allLink) allLink.href = defaultCollectionUrl + '?sort_by=best-selling';
      if (allText) allText.textContent = i18nSeeAllDefaut;
      /* Les pastilles disparaissent quand c'est un REPLI de recherche ratée, pas
         quand c'est l'état d'ouverture : là, les deux vont ensemble. */
      if (teams) teams.hidden = !!query;
      results.hidden = false;
      return true;
    }

    function lienPageRecherche(query) {
      return (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search?q=')
        + encodeURIComponent(expandQuery(query)) + '&type=product&options[prefix]=last';
    }

    function renderResults(products, query) {
      /* ⚠️ AUCUN COMPTE ANNONCÉ ICI. suggest.json ne rend pas de total, et celui
         de Shopify est le total NON filtré — c'est exactement le « 49 résultats »
         qu'il a repéré ce matin. Le lien nomme donc ce qu'il a cherché, sans
         chiffre : le vrai total est calculé sur la page, où il est vérifiable. */
      if (allLink) allLink.href = lienPageRecherche(query);
      if (allText && i18nSeeAll) allText.textContent = i18nSeeAll.replace('__QUERY__', '« ' + query + ' »');

      if (!products.length) {
        /* ⚠️ LA LIMITE EST OBLIGATOIRE ICI. Sans elle, le repli déversait les 40
           produits du tirage — invisible tant que le tirage valait 6, cassant dès
           qu'il est passé à 40. Constaté EN LIGNE le 15/08 sur « foot ». */
        if (renderDefaultResults(query, BEST_A_L_OUVERTURE)) return;
        if (label) label.textContent = '';
        list.innerHTML = '';
        var li = document.createElement('li');
        li.className = 'search-drawer__no-result';
        li.textContent = i18nNoResults.replace('__QUERY__', query);
        list.appendChild(li);
        if (teams) teams.hidden = true;
        results.hidden = false;
        return;
      }

      if (label) label.textContent = i18nResults;
      list.innerHTML = '';
      products.forEach(function (p) {
        var imgUrl = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        list.appendChild(buildProductItem(p, imgUrl));
      });

      if (teams) teams.hidden = true;
      results.hidden = false;
    }

    function fetchSuggestions(query) {
      /* Champ vide ou une seule lettre : on revient aux pastilles, pas aux
         best-sellers. Une lettre ne dit rien, une équipe si. */
      if (!query || query.length < 2) {
        montrerEquipes();
        return;
      }
      var searchUrl = (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search/suggest.json?q=') + encodeURIComponent(expandQuery(query))
        + '&resources%5Btype%5D=product'
        + '&resources%5Blimit%5D=6';
      fetch(searchUrl)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (query !== lastQuery) return;
          var products = [];
          try { products = data.resources.results.products || []; } catch(e) {}
          renderResults(products, query);
        })
        .catch(function () { results.hidden = true; });
    }

    trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);

    if (input) {
      input.addEventListener('input', function () {
        lastQuery = input.value.trim();
        clearTimeout(timer);
        timer = setTimeout(function () { fetchSuggestions(lastQuery); }, 230);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.trim().length > 0) {
          e.preventDefault();
          window.location.href = (((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'search?q=') + encodeURIComponent(expandQuery(input.value.trim())) + '&type=product';
        }
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  })();

  /* ══ Offer popup ══ */
  (function () {
    var root = document.getElementById('onix-offer');
    if (!root) return;

    var trigger     = document.getElementById('onix-offer-trigger');

    /* Devise active. EUR → codes à PRIX FIXE (2 maillots -19,99€ → 29,99€ /
       4 maillots -54,97€ → 44,99€ pile, non-abusables). Autres devises →
       codes en % (2 maillots -40% / 4 maillots -55%) qui se convertissent
       proprement. Le popup choisit le bon code par devise (selectTier). */
    var __offerIsEUR = ((window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR') === 'EUR';

    var closeBtn    = root.querySelector('.onix-offer__close');
    var backdrop    = root.querySelector('.onix-offer__backdrop');
    var grid        = document.getElementById('onix-offer-grid');
    var submitBtn   = document.getElementById('onix-offer-submit');
    var counterEl   = root.querySelector('[data-offer-count]');
    var toastEl     = document.getElementById('onix-offer-toast');
    var maxPick     = parseInt(root.dataset.max, 10) || 2;
    var btnLabel    = root.dataset.btnLabel || 'AJOUTER AU PANIER';
    var toastSizeMsg  = root.dataset.tToastSize || 'Size unavailable for one item';
    var toastErrorMsg = root.dataset.tToastError || 'Error, please try again';
    var discountCode  = root.dataset.discountCode || '';
    var offerPriceCents = parseInt(root.dataset.priceCents, 10) || 0;
    var offerPct = 40; /* % de remise du palier actif (hors EUR) — maj par selectTier */
    var btnBase = root.dataset.btnBase || 'AJOUTER AU PANIER';
    /* Devise : EUR garde le rendu Liquid "29,99€". En présentment, conversion
       au taux Shopify (arrondi à l'unité comme les prix produits). Le prix exact
       est confirmé dans le panier à l'ajout (le drawer lit la vraie valeur). */
    function priceDisplay(priceStr, cents, pct) {
      /* EUR → prix fixe affiché tel quel (29,99€ / 44,99€). Hors EUR → on affiche
         le % de remise du palier (2 maillots −40%, 4 maillots −55%) ; le
         panier/checkout porte le vrai montant converti. */
      if (__offerIsEUR) return priceStr;
      var p = (pct !== undefined && pct !== null && pct !== '') ? pct : offerPct;
      return '−' + p + '%';
    }
    var rootUrl     = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var selected    = [];
    var bundleInCart = false;
    var bundleKeys  = [];
    var busy        = false;
    var scrollY     = 0;

    /* ── Pre-parse variants once (avoid repeated JSON.parse) ── */
    var variantCache = {};
    grid.querySelectorAll('[data-offer-card]').forEach(function (card) {
      try {
        variantCache[card.dataset.handle] = JSON.parse(card.dataset.variants);
      } catch (e) {
        variantCache[card.dataset.handle] = [];
      }
    });

    /* ── Helpers ── */

    function getActiveSize() {
      var el = root.querySelector('[data-offer-size].is-active');
      return el ? el.dataset.offerSize : '';
    }

    function getVariantId(handle, size) {
      var variants = variantCache[handle];
      if (!variants || !variants.length) return null;
      if (size) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].title.toUpperCase() === size.toUpperCase()) {
            return variants[i].id;
          }
        }
        /* Size not found in variants — fallback to first available.
           Stock is not tracked so all variants are "available". */
        return variants[0].id;
      }
      return variants[0].id;
    }

    function isVariantAvailable(handle, size) {
      /* Stock is not tracked — every product is always available.
         If the exact size variant doesn't exist, we fallback to
         the first variant, so the card stays selectable. */
      var variants = variantCache[handle];
      if (!variants || !variants.length) return false;
      return true;
    }

    /** Mark cards as unavailable for the selected size */
    function updateAvailability() {
      var size = getActiveSize();
      grid.querySelectorAll('[data-offer-card]').forEach(function (card) {
        var handle = card.dataset.handle;
        var available = isVariantAvailable(handle, size);
        card.classList.toggle('is-unavailable', !available);
        /* Deselect if became unavailable */
        if (!available) {
          var idx = selected.indexOf(handle);
          if (idx !== -1) {
            selected.splice(idx, 1);
            card.classList.remove('is-selected');
          }
        }
      });
    }

    function setGlobals() {
      if (discountCode) window.__onixOfferDiscountCode = discountCode;
      window.__onixOfferPriceCents = offerPriceCents;
      window.__onixOfferQty = maxPick;
    }

    function clearGlobals() {
      delete window.__onixOfferDiscountCode;
      delete window.__onixOfferPriceCents;
      delete window.__onixOfferQty;
    }

    function extractBundleKeys(cart) {
      bundleKeys = [];
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._offer_bundle === 'true') {
          bundleKeys.push(item.key);
        }
      });
    }

    function updateState() {
      if (counterEl) counterEl.textContent = selected.length;
      submitBtn.disabled = selected.length < maxPick;
      grid.querySelectorAll('[data-offer-card]').forEach(function (card) {
        card.setAttribute('aria-checked', selected.indexOf(card.dataset.handle) !== -1 ? 'true' : 'false');
      });
    }

    /* ── Tier selector (2 maillots / 4 maillots) ── */
    function applyTier(priceStr) {
      var money = priceDisplay(priceStr, offerPriceCents);
      var priceTag = root.querySelector('.onix-offer__price-tag');
      if (priceTag) priceTag.textContent = money;
      var subQty = root.querySelector('[data-offer-sub-qty]');
      if (subQty) subQty.textContent = maxPick;
      var maxEl = root.querySelector('[data-offer-max]');
      if (maxEl) maxEl.textContent = maxPick;
      btnLabel = btnBase + ' — ' + money;
      if (submitBtn && !busy) submitBtn.textContent = btnLabel;
    }

    function selectTier(pill) {
      root.querySelectorAll('[data-offer-tier]').forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      maxPick = parseInt(pill.dataset.tierMax, 10) || 2;
      offerPriceCents = parseInt(pill.dataset.tierCents, 10) || 0;
      offerPct = parseInt(pill.dataset.tierPct, 10) || 40;
      /* Code selon la devise : EUR = prix fixe (a7x2k9mq pour 2, b8z3p4wh pour 4),
         hors EUR = % (c5w2j8nk pour 2 = -40%, d8k4h2nv pour 4 = -55%). */
      discountCode = (__offerIsEUR ? pill.dataset.tierCode : pill.dataset.tierCodeInt) || pill.dataset.tierCode || '';
      /* Trim the selection when switching to a smaller tier. */
      while (selected.length > maxPick) {
        var h = selected.pop();
        var card = grid.querySelector('[data-offer-card][data-handle="' + h + '"]');
        if (card) card.classList.remove('is-selected');
      }
      applyTier(pill.dataset.tierPrice);
      updateState();
      /* If a bundle is already in cart and the new tier is fully picked, re-sync. */
      if (bundleInCart && selected.length === maxPick) syncCartWithSelection();
    }

    function setLoading(loading) {
      submitBtn.disabled = loading;
      submitBtn.textContent = loading ? '...' : btnLabel;
    }

    /** Show a toast message (auto-hides after 3s) */
    var toastTimer = null;
    function showToast(msg) {
      if (!toastEl) return;
      toastEl.textContent = msg;
      toastEl.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 3000);
    }

    /* ── iOS-safe scroll lock ── */

    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.overflow = 'hidden';
    }

    /* ⛔ IL RELÂCHAIT INCONDITIONNELLEMENT — corrigé le 05/09.
       C'est exactement le défaut du 23/08 (« chacun relâche ce qu'il a pris,
       pas ce que le voisin tient encore ») : il a été corrigé dans la
       newsletter et écrit d'emblée dans la proposition de langue, mais CETTE
       pop-up-ci était restée telle quelle. Si elle se ferme pendant qu'une
       autre surface est ouverte, elle balaie le verrou du voisin ET rappelle
       `window.scrollTo` avec SON propre scrollY : la page défile derrière un
       calque ouvert, à une position arbitraire.
       Aujourd'hui son déclencheur est dans `.site-header` (z 100), donc
       couvert dès qu'un calque est levé — le trou n'est pas encore atteignable
       par un clic. Il le deviendra au premier second déclencheur (le tiroir de
       panier mentionne déjà cette offre). */
    function autreSurfaceVerrouille() {
      var nl = document.getElementById('onix-nl');
      if (nl && nl.style.display && nl.style.display !== 'none') return true;
      if (document.body.classList.contains('if-modal-open')) return true;
      return !!document.querySelector(
        '.onix-langue.is-open, .onix-cart-drawer.is-open, [data-cart-drawer].is-open,'
        + '.search-drawer.is-open, .if-modal.is-open, .onix-wheel.is-open'
      );
    }

    function unlockScroll() {
      if (autreSurfaceVerrouille()) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.overflow = '';
      window.scrollTo(0, scrollY);
    }

    /* ── Open / Close ── */

    function openOffer() {
      fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bundleItems = cart.items.filter(function (item) {
            return item.properties && item.properties._offer_bundle === 'true';
          });

          selected = [];
          bundleKeys = [];
          grid.querySelectorAll('.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });

          if (bundleItems.length > 0) {
            bundleInCart = true;
            bundleItems.forEach(function (item) {
              var card = grid.querySelector('[data-offer-card][data-handle="' + item.handle + '"]');
              if (card) {
                selected.push(item.handle);
                card.classList.add('is-selected');
              }
              bundleKeys.push(item.key);
            });
          } else {
            bundleInCart = false;
          }
          updateAvailability();
          updateState();
          showPopup();
        })
        .catch(function () {
          updateAvailability();
          showPopup();
        });
    }

    /* ⚠️ SYMÉTRIE AJOUTÉE LE 05/09. La newsletter sait attendre, la
       proposition de langue sait attendre — cette pop-up-ci ne consultait
       RIEN et s'ouvrait par-dessus n'importe quoi, à 9998. */
    function showPopup() {
      if (document.querySelector('.onix-langue.is-open')) return;
      root.classList.add('is-open');
      root.classList.remove('is-closing');
      root.setAttribute('aria-hidden', 'false');
      lockScroll();
    }

    function closeOffer() {
      root.classList.add('is-closing');
      setTimeout(function () {
        root.classList.remove('is-open', 'is-closing');
        root.setAttribute('aria-hidden', 'true');
        unlockScroll();
      }, 220);
    }

    /* ── Cart sync ── */

    function syncCartWithSelection() {
      if (busy) return;
      busy = true;
      var size = getActiveSize();

      var updates = {};
      bundleKeys.forEach(function (key) { updates[key] = 0; });

      var removePromise = bundleKeys.length > 0
        ? fetch(rootUrl + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
        : Promise.resolve();

      removePromise.then(function () {
        var variantIds = selected.map(function (handle) {
          return getVariantId(handle, size);
        }).filter(Boolean);

        if (variantIds.length < selected.length) {
          showToast(toastSizeMsg);
          busy = false;
          return;
        }

        var items = variantIds.map(function (id) {
          return { id: id, quantity: 1, properties: { _offer_bundle: 'true', _offer_code: discountCode, _offer_qty: String(maxPick) } };
        });

        return fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('cart-add-failed');
          /* On POSE le code offre TOUT DE SUITE (avant le refresh) → le sous-total
             affiche directement le prix réduit, sans clignotement prix-plein→offre. */
          if (discountCode) {
            return fetch(rootUrl + 'discount/' + encodeURIComponent(discountCode)).then(function () {
              return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
            });
          }
          return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
        }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        if (!cart) return;
        extractBundleKeys(cart);
        bundleInCart = true;
        setGlobals();
        if (window.__onixRefreshCart) window.__onixRefreshCart();
        busy = false;
      }).catch(function () {
        showToast(toastErrorMsg);
        busy = false;
      });
    }

    /* ── Event listeners ── */

    if (trigger) trigger.addEventListener('click', openOffer);
    if (closeBtn) closeBtn.addEventListener('click', closeOffer);
    if (backdrop) backdrop.addEventListener('click', closeOffer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) closeOffer();
    });

    /* Size selection — also update stock availability */
    root.querySelectorAll('[data-offer-size]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        root.querySelectorAll('[data-offer-size]').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        updateAvailability();
        updateState();
        if (bundleInCart && selected.length === maxPick) syncCartWithSelection();
      });
    });

    /* Tier selection (2 / 4 maillots) */
    root.querySelectorAll('[data-offer-tier]').forEach(function (pill) {
      pill.addEventListener('click', function () { selectTier(pill); });
      /* Convertit le prix affiché du bouton de palier dans la devise active
         (EUR → inchangé via priceDisplay). Sans ça le bouton montrait
         « 29,99€ / 44,99€ » en dur même en GBP/CHF/CAD/AUD. */
      var priceLabel = pill.querySelector('[data-tier-price-label]');
      if (priceLabel) priceLabel.textContent = priceDisplay(pill.dataset.tierPrice, parseInt(pill.dataset.tierCents, 10) || 0, pill.dataset.tierPct);
    });
    /* Init the active tier — sets price tag, counter denominator, button label
       and the presentment-currency conversion (replaces the old one-shot init). */
    (function () {
      var active = root.querySelector('[data-offer-tier].is-active') || root.querySelector('[data-offer-tier]');
      if (active) selectTier(active);
    })();

    /* Card toggle (delegated) */
    grid.addEventListener('click', function (e) {
      var card = e.target.closest('[data-offer-card]');
      if (!card || busy || card.classList.contains('is-unavailable')) return;

      var handle = card.dataset.handle;
      var idx = selected.indexOf(handle);

      if (idx !== -1) {
        selected.splice(idx, 1);
        card.classList.remove('is-selected');
      } else {
        if (selected.length >= maxPick) return;
        selected.push(handle);
        card.classList.add('is-selected');
      }
      updateState();

      if (bundleInCart && selected.length === maxPick) syncCartWithSelection();
    });

    /* Keyboard support for cards */
    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        var card = e.target.closest('[data-offer-card]');
        if (card) { e.preventDefault(); card.click(); }
      }
    });

    /* Submit */
    submitBtn.addEventListener('click', function () {
      if (selected.length < maxPick) return;

      if (bundleInCart) {
        syncCartWithSelection();
        closeOffer();
        if (window.__onixOpenDrawer) window.__onixOpenDrawer();
        return;
      }

      var size = getActiveSize();

      var variantIds = selected.map(function (handle) {
        return getVariantId(handle, size);
      }).filter(Boolean);

      if (variantIds.length < selected.length) {
        showToast(toastSizeMsg);
        return;
      }

      var items = variantIds.map(function (id) {
        return { id: id, quantity: 1, properties: { _offer_bundle: 'true' } };
      });

      /* v2026-04-15-offer-instant: close popup + open drawer IMMEDIATELY
         so the user sees a response on click. The drawer shows its current
         state (which may still be empty) and the bundle card pops in as
         soon as the background add.js + refresh resolves. Previously we
         blocked on two sequential fetches (~500-800ms) BEFORE opening the
         drawer, which felt unresponsive. */
      setGlobals();
      bundleInCart = true;

      /* v2026-04-15-offer-bundle-optimistic: build a fake bundle card from
         the selected offer cards (title, image, size, variantId) and inject
         it into the drawer BEFORE the fetch. refreshCart will replace it
         with server-keyed data once add.js resolves. */
      var optimisticItems = selected.map(function (handle, i) {
        var card = grid.querySelector('[data-offer-card][data-handle="' + handle + '"]');
        var img = card ? card.querySelector('img') : null;
        var titleEl = card ? card.querySelector('.onix-offer__card-title') : null;
        var subEl = card ? card.querySelector('.onix-offer__card-sub') : null;
        var title = '';
        if (titleEl) title = titleEl.textContent.trim();
        if (subEl && subEl.textContent.trim()) title += ' - ' + subEl.textContent.trim();
        var variants = variantCache[handle] || [];
        var variantObj = null;
        for (var vi = 0; vi < variants.length; vi++) {
          if (variants[vi].id === variantIds[i]) { variantObj = variants[vi]; break; }
        }
        var unitPrice = variantObj && typeof variantObj.price === 'number' ? variantObj.price : 0;
        return {
          variantId: variantIds[i],
          title: title,
          image: img ? (img.currentSrc || img.src || '') : '',
          size: size,
          url: '/products/' + handle,
          fullUnitCents: unitPrice
        };
      });

      /* Cible du prix offre selon la devise (carte optimiste, étalée
         uniformément, reste sur la 1re ligne) :
           - EUR  : prix FIXE (offerPriceCents = 2999 / 4499).
           - hors EUR : remise % du palier (2 maillots −40%, 4 maillots −55%). */
      var fullTotalCents = optimisticItems.reduce(function (s, it) { return s + (it.fullUnitCents || 0); }, 0);
      var targetTotal = __offerIsEUR ? (offerPriceCents || 0) : Math.round(fullTotalCents * (1 - offerPct / 100));
      if (targetTotal > 0 && optimisticItems.length) {
        var n = optimisticItems.length;
        var perUnit = Math.floor(targetTotal / n);
        var remainder = targetTotal - perUnit * n;
        optimisticItems.forEach(function (it, idx) {
          it.displayCents = perUnit + (idx === 0 ? remainder : 0);
        });
      } else {
        optimisticItems.forEach(function (it) { it.displayCents = it.fullUnitCents || 0; });
      }

      /* Conversion présentment (cents EUR → devise active) sinon formatMoney
         habille du mauvais symbole sans convertir. EUR → rate 1, inchangé.
         La carte serveur (refreshCart) recolle avec les vraies allocations
         Shopify (écart de quelques centimes accepté). */
      var presRate = parseFloat((window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || '1') || 1;
      var injectTotal = targetTotal;
      if (presRate !== 1) {
        optimisticItems.forEach(function (it) {
          it.displayCents = Math.round((it.displayCents || 0) * presRate);
          it.fullUnitCents = Math.round((it.fullUnitCents || 0) * presRate);
        });
        injectTotal = Math.round(targetTotal * presRate);
      }

      closeOffer();
      if (window.__onixOpenDrawer) window.__onixOpenDrawer();
      if (window.__onixInjectOptimisticBundle) {
        window.__onixInjectOptimisticBundle(optimisticItems, injectTotal);
      }

      /* Code offre = compte (2/4) + devise (cohérent avec
         cart-drawer-promo-suggest.js → offerCodeToApply). Priorité au code déjà
         dans les propriétés des items, fallback sur le calcul. */
      var offerCode = (items[0] && items[0].properties && items[0].properties._offer_code)
        || ((items.length === 4) ? (__offerIsEUR ? 'b8z3p4wh' : 'd8k4h2nv') : (__offerIsEUR ? 'a7x2k9mq' : 'c5w2j8nk'));

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        /* On POSE le code offre TOUT DE SUITE (avant le refresh) → le sous-total
           affiche directement le prix réduit, sans clignotement prix-plein→offre. */
        if (offerCode) {
          return fetch(rootUrl + 'discount/' + encodeURIComponent(offerCode)).then(function () {
            return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
          });
        }
        return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } });
      }).then(function (r) { return r.json(); })
      .then(function (cart) {
        extractBundleKeys(cart);
        if (window.__onixRefreshCart) window.__onixRefreshCart();
      }).catch(function () {
        bundleInCart = false;
        showToast(toastErrorMsg);
      });
    });

    /* Reset state when bundle items are removed from cart drawer */
    window.__onixResetOfferBundle = function () {
      bundleInCart = false;
      bundleKeys = [];
      selected = [];
      grid.querySelectorAll('.is-selected').forEach(function (c) { c.classList.remove('is-selected'); });
      updateState();
      clearGlobals();
    };
  })();

  /* Onix 2026-06-21 (Yacine) — popup offre : titre = NOM DE L'ÉQUIPE seul.
     Les titres produits sont incohérents (« France » mais aussi « Paris-Saint-Germain
     Domicile Édition LDC 2026 »). On isole l'équipe en retirant type / saison / édition /
     couleur. Rendu serveur = 1er segment (fallback) ; ce JS l'affine après le DOM. */
  (function () {
    function onixTeamName(raw) {
      var s = String(raw || '').split(' - ')[0].split(' – ')[0];
      // retire la description (type de maillot, édition…) dès le 1er mot-clé rencontré
      s = s.replace(/\s+(maillots?|domicile|ext[ée]rieur|third|home|away|[ée]dition|concept|night|training|entra[îi]nement|pr[ée]-?match|gardien|collector|vintage|r[ée]tro|sp[ée]ciale?|anniversaire|fourth|quatri[èe]me|troisi[èe]me|deuxi[èe]me|2\s*[ée]toiles|back\s+to\s+back|ldc|cdm)\b[\s\S]*$/i, '');
      // retire la saison/année (2026, 25/26, 2026/27) — préserve un « Schalke 04 »
      s = s.replace(/\s+(20\d{2}|\d{2}\s*\/\s*\d{2})(\s*\/\s*\d{2,4})?[\s\S]*$/, '');
      s = s.replace(/\(\s*psg\s*\)/ig, '').replace(/\s{2,}/g, ' ').trim();
      return s || String(raw || '').trim();
    }
    function applyTeamNames() {
      try {
        var els = document.querySelectorAll('.onix-offer__card-title');
        for (var i = 0; i < els.length; i++) {
          if (els[i].dataset.teamDone) continue;
          els[i].textContent = onixTeamName(els[i].textContent);
          els[i].dataset.teamDone = '1';
        }
      } catch (e) { /* dégradation : le 1er segment reste affiché */ }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', applyTeamNames);
    } else {
      applyTeamNames();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onix-discount-bar"]) return;
  try {
    
(function () {
  var bar = document.getElementById('onix-discount-bar');
  if (!bar) return;
  var tiers = JSON.parse(bar.dataset.tiers || '[]');
  if (!tiers.length) return;

  /* Expose the merchant-configured tier codes as a public whitelist.
     cart-drawer-discount.js reads window.OnixValidCodes to distinguish
     a fake code from a real code silently blocked by the bundle:
     - bundle active + code in whitelist  → "Non cumulable" (real code)
     - bundle active + code NOT in list   → "Code invalide" (likely fake)
     Codes are already public (the bar displays them on screen), so
     exposing the list is not a security concern. */
  window.OnixValidCodes = tiers
    .map(function (t) { return (t.code || '').toUpperCase(); })
    .filter(Boolean);

  var collapsed = document.getElementById('onix-bar-collapsed');
  var expanded = document.getElementById('onix-bar-expanded');
  var arrow = document.getElementById('onix-bar-toggle');
  var fill = document.getElementById('onix-bar-fill');
  var fillExp = document.getElementById('onix-bar-fill-exp');
  var summary = document.getElementById('onix-bar-summary');
  var message = document.getElementById('onix-bar-message');
  var isOpen = false;
  var ARROW = ' <span class="onix-bar__arrow">▲</span>';

  /* i18n — templates traduits injectés via data-t-* (escape côté Liquid).
     Le JS remplace les placeholders {{...}} par les fragments HTML
     (spans accent). Aucune chaîne en dur : adapte à la langue active. */
  var T = {
    jerseys:   bar.dataset.tJerseys    || 'jerseys',
    jerseyOne: bar.dataset.tJerseyOne  || 'jersey',
    addUnlock: bar.dataset.tAddUnlock  || 'Add {{n}} to unlock {{reward}}',
    tierEq:    bar.dataset.tTierEq     || '{{qty}} {{jerseys}} = {{reward}}',
    available: bar.dataset.tAvailable  || 'available',
    codeColon: bar.dataset.tCodeColon  || 'code:',
    moreFor:   bar.dataset.tMoreFor    || '{{n}} more for {{reward}}',
    copied:    bar.dataset.tCopied     || 'Copied ✓'
  };
  function fmt(tpl, map) {
    return tpl.replace(/\{\{(\w+)\}\}/g, function (_, k) {
      return map[k] != null ? map[k] : '';
    });
  }
  function accent(v) { return '<span class="onix-bar__accent">' + v + '</span>'; }
  function jerseyWord(n) { return n === 1 ? T.jerseyOne : T.jerseys; }

  /* Publie la hauteur visible de la barre dans --onix-bar-height pour que
     les éléments fixés en bas (back-to-top, etc.) puissent se positionner
     au-dessus sans se superposer — qu'elle soit fermée ou ouverte. */
  function publishBarHeight() {
    if (!bar) return;
    var h = 0;
    if (!bar.classList.contains('is-hidden') && !bar.classList.contains('is-hidden-scroll') && !bar.classList.contains('is-hidden-kbd')) {
      var rect = bar.getBoundingClientRect();
      h = Math.ceil(rect.height) + 10; /* 10px = bottom offset de la barre */
    }
    document.documentElement.style.setProperty('--onix-bar-height', h + 'px');
  }

  function toggleExpand() {
    isOpen = !isOpen;
    expanded.hidden = !isOpen;
    collapsed.style.display = isOpen ? 'none' : '';
    if (arrow) arrow.textContent = isOpen ? '▼' : '▲';
    requestAnimationFrame(publishBarHeight);
  }

  collapsed.addEventListener('click', toggleExpand);
  expanded.addEventListener('click', function (e) {
    if (e.target.closest('[data-copy]')) return;
    toggleExpand();
  });

  document.addEventListener('click', function (e) {
    if (isOpen && !bar.contains(e.target)) {
      isOpen = false;
      expanded.hidden = true;
      collapsed.style.display = '';
      if (arrow) arrow.textContent = '▲';
      requestAnimationFrame(publishBarHeight);
    }
  });

  /* Initial publish + recalcule sur resize et sur changement de classe
     (is-hidden quand le cart drawer s'ouvre). */
  publishBarHeight();
  window.addEventListener('resize', publishBarHeight);
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(publishBarHeight).observe(bar, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  /* ACCUEIL UNIQUEMENT (data-home-scroll="1") : la barre est masquée à
     l'ouverture (is-hidden-scroll) et apparaît dès qu'on scrolle (seuil 40px),
     puis se recache si on revient tout en haut. Sur les autres pages
     data-home-scroll est vide → la barre reste visible directement.
     Classe DÉDIÉE (≠ is-hidden du cart drawer) pour ne pas se marcher dessus. */
  /* Clavier mobile : quand un champ de saisie a le focus, le viewport se
     réduit et un fixed bottom vient se coller au-dessus du clavier — la
     barre se retrouvait « au milieu de l'écran » (Yacine 2026-07-09). On
     la masque tant qu'un champ est actif. focusout est différé : passer
     d'un champ à l'autre ne fait pas clignoter la barre. */
  function onixBarIsTextField(el) {
    if (!el || !el.matches) return false;
    return el.matches('input:not([type=checkbox]):not([type=radio]):not([type=button]):not([type=submit]):not([type=range]), textarea, select, [contenteditable="true"]');
  }
  document.addEventListener('focusin', function (e) {
    if (onixBarIsTextField(e.target)) {
      bar.classList.add('is-hidden-kbd');
      publishBarHeight();
    }
  });
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (!onixBarIsTextField(document.activeElement)) {
        bar.classList.remove('is-hidden-kbd');
        publishBarHeight();
      }
    }, 150);
  });

  if (bar.dataset.homeScroll === '1') {
    var barScrollTick = false;
    var updateBarScrollHide = function () {
      barScrollTick = false;
      if ((window.scrollY || 0) > 40) {
        bar.classList.remove('is-hidden-scroll');
      } else {
        bar.classList.add('is-hidden-scroll');
      }
    };
    bar.classList.add('is-hidden-scroll');   /* masquée tant qu'on n'a pas scrollé */
    bar.setAttribute('data-bar-ready', '');  /* la classe prend le relais du masque CSS anti-flash */
    window.addEventListener('scroll', function () {
      if (barScrollTick) return;
      barScrollTick = true;
      requestAnimationFrame(updateBarScrollHide);
    }, { passive: true });
    updateBarScrollHide();
  }
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(publishBarHeight).observe(bar);
  }

  /* ── Bannière PUREMENT VISUELLE ───────────────────────────────────
     L'application des codes (bundle offre + paliers onix3/4/toast/gift/
     free) est gérée UNIQUEMENT par cart-drawer-promo-suggest.js (source
     unique, avec settling anti-spam). La bannière ne fait QUE la jauge,
     les messages et la pastille de code — elle ne pose/efface AUCUN code,
     pour éviter les races (3 moteurs concurrents = clignotement au spam). */
  var LROOT=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/'; if(LROOT.slice(-1)!=='/')LROOT+='/';

  function update(count) {
    /* `count` is the NON-bundle item count (i.e. total items minus those
       with property _offer_bundle=true). The bundle is its own offer
       (code bundle dédié) — the tier bar measures only the "extra" maillots
       added on top, so a customer with just the bundle sees 0% fill.
       Purement visuel : aucune application de code ici. */

    /* Calculate fill % based on tier positions (20%, 40%, 60%, 80%, 100%)
       instead of linear ratio. When a tier is reached, the fill goes to
       that dot position. Between tiers, it interpolates smoothly. */
    var pct = 0;
    var activeIdx = -1;
    for (var i = tiers.length - 1; i >= 0; i--) {
      if (count >= tiers[i].qty) { activeIdx = i; break; }
    }
    if (activeIdx >= 0) {
      var dotPos = (activeIdx + 1) * 20; /* 20%, 40%, 60%, 80%, 100% */
      if (activeIdx < tiers.length - 1) {
        /* Interpolate progress toward next tier */
        var nextQty = tiers[activeIdx + 1].qty;
        var curQty = tiers[activeIdx].qty;
        var progress = (count - curQty) / (nextQty - curQty);
        pct = dotPos + (progress * 20);
      } else {
        pct = 100;
      }
    } else if (count > 0) {
      /* Below tier 1: interpolate from 0 to first dot (20%) */
      pct = (count / tiers[0].qty) * 20;
    }
    fill.style.width = pct + '%';
    if (fillExp) fillExp.style.width = pct + '%';

    bar.querySelectorAll('[data-dot], [data-dot-exp]').forEach(function (dot) {
      var idx = parseInt(dot.dataset.dot || dot.dataset.dotExp, 10) - 1;
      if (idx < tiers.length) dot.classList.toggle('is-reached', count >= tiers[idx].qty);
    });

    bar.querySelectorAll('.onix-bar__tier').forEach(function (el, idx) {
      el.classList.toggle('is-active', idx === activeIdx);
    });

    function tierEq(tier) {
      return fmt(T.tierEq, { qty: tier.qty, jerseys: jerseyWord(tier.qty), reward: accent(tier.label) });
    }

    if (count === 0) {
      message.innerHTML = fmt(T.addUnlock, {
        n: accent(tiers[0].qty + ' ' + jerseyWord(tiers[0].qty)),
        reward: accent(tiers[0].label)
      });
      summary.innerHTML = tierEq(tiers[0]) + ' · ' + tierEq(tiers[1]) + ARROW;
    } else if (activeIdx >= 0) {
      var c = tiers[activeIdx];
      var pill = c.code ? ' <span class="onix-bar__code-pill" data-copy="' + c.code + '">' + c.code + '</span>' : '';
      var msg = '🎁 ' + accent(c.label) + ' ' + T.available + pill;
      var summ = '🎁 ' + accent(c.label) + ' ' + T.available;
      if (c.code) summ += ' — ' + T.codeColon + ' ' + accent(c.code);
      if (activeIdx < tiers.length - 1) {
        var n = tiers[activeIdx + 1];
        var rem = n.qty - count;
        msg += ' — ' + fmt(T.moreFor, { n: accent(rem + ' ' + jerseyWord(rem)), reward: accent(n.label) });
        summ += ' — ' + fmt(T.moreFor, { n: rem, reward: accent(n.label) });
      }
      message.innerHTML = msg;
      summary.innerHTML = summ + ARROW;
    } else {
      var rem = tiers[0].qty - count;
      var more = fmt(T.moreFor, { n: accent(rem + ' ' + jerseyWord(rem)), reward: accent(tiers[0].label) });
      var moreCap = more.charAt(0).toUpperCase() + more.slice(1);
      message.innerHTML = moreCap;
      summary.innerHTML = moreCap + ARROW;
    }
  }

  bar.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-copy]');
    if (!pill) return;
    var code = pill.dataset.copy;
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () {
        var orig = pill.textContent;
        pill.textContent = T.copied;
        setTimeout(function () { pill.textContent = orig; }, 1500);
      });
    }
  });

  /* Hide bar when cart drawer is open */
  var drawerRoot = document.querySelector('[data-cart-drawer-root]');
  if (drawerRoot) {
    new MutationObserver(function () {
      bar.classList.toggle('is-hidden', drawerRoot.classList.contains('is-open'));
    }).observe(drawerRoot, { attributes: true, attributeFilter: ['class'] });
  }

  /* Compute hasBundle + nonBundleCount from a /cart.js fetch and call
     update(). Coalesces rapid back-to-back calls (cart:refresh +
     MutationObserver often both fire on the same change) so we don't
     spam fetches or trigger re-renders. */
  var _refreshTimer = null;
  var _refreshing = false;
  var _refreshPending = false;

  /* Race-detector for the bundle add path :
     The OFFRE popup fires /cart/add.js with `_offer_bundle:true`
     properties on each line item. There's a brief window (~150-500
     ms) between Shopify writing the items and Shopify returning the
     properties on /cart.js. During that window, item_count > 0 BUT
     no items carry _offer_bundle, so the bar would compute
     nonBundleCount = item_count and FILL UP — only to drop back to
     0 % a few hundred ms later when properties land. The user sees
     a flicker.
     `cart-drawer.js` raises `window.__onixOptimisticBundleQty` and
     `__onixOptimisticBundleUntil` whenever it injects an optimistic
     bundle row. When that hint is fresh AND /cart.js still shows
     fewer bundle items than expected, we DEFER the bar update and
     retry after ~250 ms. After ~5 s the hint expires and the bar
     trusts whatever Shopify returns. */
  function readCartAndUpdate() {
    return fetch(LROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bundleCount = 0;
        (cart.items || []).forEach(function (i) {
          if (i.properties && i.properties._offer_bundle === 'true') {
            bundleCount += (i.quantity || 0);
          }
        });
        var itemCount = cart.item_count || 0;

        /* Optimistic-bundle hint set by cart-drawer.js when injecting
           the bundle UI before Shopify has confirmed the property
           write. During this window we treat AT LEAST `optimisticQty`
           items as bundle, even if /cart.js says otherwise. The hint
           naturally expires (cart-drawer.js sets a ~5 s deadline) so
           we always fall back to "trust /cart.js" eventually. */
        var optimisticQty = Number(window.__onixOptimisticBundleQty || 0);
        var optimisticUntil = Number(window.__onixOptimisticBundleUntil || 0);
        var optimisticActive = optimisticQty > 0 && Date.now() < optimisticUntil;

        var effectiveBundle = optimisticActive
          ? Math.max(bundleCount, optimisticQty)
          : bundleCount;
        var nonBundleCount = Math.max(0, itemCount - effectiveBundle);
        update(nonBundleCount);
      })
      .catch(function () { /* swallow; bar stays in last known state */ });
  }

  function refresh() {
    /* Si fetch en cours, on marque pending pour re-fire après — surtout pas
       skip silencieux (sinon la bar reste sur l'état stale lu pendant que
       change.js était in-flight, classique sur stepper +/- du drawer). */
    if (_refreshing) {
      _refreshPending = true;
      return;
    }
    if (_refreshTimer) return;  /* déjà programmé dans 50ms */
    _refreshTimer = setTimeout(function () {
      _refreshTimer = null;
      _refreshing = true;
      readCartAndUpdate().then(function () {
        _refreshing = false;
        if (_refreshPending) {
          _refreshPending = false;
          refresh();  // re-fire pour lire le state final
        }
      });
    }, 50);
  }

  /* Initial load */
  refresh();

  /* React to cart:refresh events (fired by cart-drawer.js after every change) */
  document.addEventListener('cart:refresh', refresh);

  /* Force refresh quand la page revient du bfcache mobile (back nav,
     swipe-back iOS, app switcher Android) — sinon la bar reste figée
     à l'état précédent et l'utilisateur doit hard-refresh. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });

  /* Force refresh quand la page redevient visible (switch tab, retour
     d'arrière-plan sur mobile, dismiss du keyboard). */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') refresh();
  });

  /* Watch the cart count badge — it updates on EVERY cart change instantly.
     When its text changes, refresh the bar. This is the most reliable way
     to stay in sync because the cart drawer updates these nodes after every
     add/remove/quantity change, regardless of which code path triggered it.
     We don't trust the badge value alone because it includes BUNDLE items —
     refresh() pulls the full /cart.js to split bundle vs regular. */
  var countNodes = document.querySelectorAll('[data-cart-count]');
  if (countNodes.length) {
    var lastCount = countNodes[0].textContent.trim();
    new MutationObserver(function () {
      var newCount = countNodes[0].textContent.trim();
      if (newCount !== lastCount) {
        lastCount = newCount;
        refresh();
      }
    }).observe(countNodes[0], { childList: true, characterData: true, subtree: true });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onix-home-comparator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function initComparator(sec) {
      if (sec.dataset.cmpInit) return;
      sec.dataset.cmpInit = '1';
      var btn = sec.querySelector('[data-comparator-toggle]');
      var detail = sec.querySelector('.onix-comparator__detail');
      if (!detail) return;

      /* Sur MOBILE le détail est toujours déplié (CSS force grid-rows:1fr et masque
         le bouton « Voir ») → il ne doit JAMAIS être inert/aria-hidden. Sur desktop,
         inert tant qu'il n'est pas ouvert via le bouton (CTA invisible non focusable). */
      function syncA11y() {
        var visible = mq.matches || sec.classList.contains('is-open');
        detail.inert = !visible;
        detail.setAttribute('aria-hidden', visible ? 'false' : 'true');
      }

      if (btn) {
        btn.addEventListener('click', function () {
          var open = sec.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          syncA11y();
          if (open && !mq.matches) {
            /* Scroll APRÈS la transition d'ouverture (grid-rows ~0.34s), via
               setTimeout (pas rAF, gelé sur onglet caché) → vise la géométrie finale. */
            setTimeout(function () {
              detail.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            }, 360);
          }
        });
      }

      syncA11y();
      if (mq.addEventListener) mq.addEventListener('change', syncA11y);
      else if (mq.addListener) mq.addListener(syncA11y);
    }
    document.querySelectorAll('[data-comparator]').forEach(initComparator);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onix-home-promo-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const banner = document.querySelector('[data-promo-banner]');
    if (!banner) return;

    const slides = banner.querySelectorAll('[data-slide]');
    const dots = banner.querySelectorAll('[data-dot]');
    if (slides.length <= 1) return;

    let current = 0;
    let timer = null;

    const goTo = (index) => {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    };

    const startTimer = () => {
      clearInterval(timer);
      timer = setInterval(() => goTo(current + 1), 6000);
    };

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        goTo(parseInt(dot.dataset.dot));
        startTimer();
      });
    });

    slides.forEach((slide) => {
      slide.addEventListener('click', (e) => {
        if (e.target.closest('.onix-promo-banner__btn')) return;
        if (e.target.closest('.onix-promo-banner__grid')) return;
        if (e.target.closest('.onix-promo-pcard')) return;
        goTo(current + 1);
        startTimer();
      });
    });

    startTimer();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page"]) return;
  try {
    
  (function () {
    function wrapPageTables() {
      var tables = document.querySelectorAll('.onix-page__content table');

      tables.forEach(function (table) {
        if (table.parentElement && table.parentElement.classList.contains('onix-page__table-scroll')) {
          return;
        }

        var wrapper = document.createElement('div');
        wrapper.className = 'onix-page__table-scroll';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', wrapPageTables);
    } else {
      wrapPageTables();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* ── Back button (no inline onclick) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-onix-back]');
    if (!btn) return;
    if (document.referrer && document.referrer.indexOf(location.hostname) !== -1) {
      history.back();
    } else {
      location.href = '/';
    }
  });

  /* ── Titre dans la back-bar : réduit la taille pour tenir TOUJOURS sur 1 ligne ── */
  (function () {
    function fitBackTitle() {
      var t = document.querySelector('.onix-product__back-title .onix-product__title');
      if (!t) return;
      t.style.fontSize = '';
      var size = parseFloat(getComputedStyle(t).fontSize) || 18;
      var guard = 0;
      while (t.scrollWidth > t.clientWidth + 1 && size > 11 && guard < 80) {
        size -= 0.5;
        guard++;
        t.style.fontSize = size + 'px';
      }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fitBackTitle);
    } else {
      fitBackTitle();
    }
    window.addEventListener('resize', fitBackTitle);
    if (document.fonts && document.fonts.ready) { document.fonts.ready.then(fitBackTitle); }
  })();

  /* Numeric-input cap (data-numeric-max) is handled globally in
     assets/cart-drawer-utils.js which loads on every page. Keeping the
     handler there ensures the quickadd popup — which can open from a
     collection / homepage where product.liquid's {% javascript %} block
     does NOT run — also gets the digit filter. */

  /* ── Bundle : compagnon PERSONNALISÉ par maillot via l'API Shopify
     recommendations (co-achats réels, intent=related). Fallback = rendu
     Liquid (meilleur vendeur). ── */
  (async () => {
    const box = document.querySelector('.onix-bundle2');
    if (!box || !box.dataset.productId) return;
    try {
      const root = (window.Shopify?.routes?.root || '/');
      const r = await fetch(root + 'recommendations/products.json?product_id=' + box.dataset.productId + '&limit=6&intent=related');
      if (!r.ok) return;
      const prods = ((await r.json()).products || []).filter(p => p.available && String(p.id) !== String(box.dataset.productId));
      const c = prods[0];
      if (!c) return;
      const slot = box.querySelector('.onix-bundle2__item:last-child');
      const img = slot?.querySelector('.onix-bundle2__img');
      const link = slot?.querySelector('a.onix-bundle2__imgwrap');
      if (img && c.featured_image) {
        img.src = c.featured_image + (c.featured_image.includes('?') ? '&' : '?') + 'width=320';
        img.removeAttribute('srcset');
        img.alt = c.title;
      }
      if (link) link.href = c.url;
      const nameEl = slot?.querySelector('.onix-bundle2__name');
      if (nameEl) {
        const parts = c.title.split(/\s[–-]\s/);
        const kept = parts.length > 1 ? parts.slice(0, -1) : parts;
        nameEl.textContent = '';
        const l1 = document.createElement('span'); l1.textContent = kept[0]; nameEl.appendChild(l1);
        if (kept.length > 1) { const l2 = document.createElement('span'); l2.textContent = kept.slice(1).join(' – '); nameEl.appendChild(l2); }
      }
      const total = (parseInt(box.dataset.currentCents, 10) || 0) + c.price;
      const off = Math.floor(total * 15 / 100);
      const fmt = (cents) => {
        const cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
        if (cur === 'EUR') return (cents / 100).toFixed(2).replace('.', ',') + '€';
        try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
        catch (_) { return (cents / 100).toFixed(2) + ' ' + cur; }
      };
      const pEl = box.querySelector('[data-bundle-price]');
      const cEl = box.querySelector('[data-bundle-compare]');
      if (pEl) pEl.textContent = fmt(total - off);
      if (cEl) cEl.textContent = fmt(total);
      const btn = box.querySelector('.onix-bundle2__btn');
      if (btn) btn.dataset.quickAdd = c.handle;
    } catch (_) { /* fallback SSR conservé */ }
  })();

  /* ══ COLORIS — NAVIGATION SANS RECHARGEMENT ════════════════════════════
     Sa demande du 29/08, deux fois : « je veux pas qu'on ressente un
     changement de page ». Le préchargement au survol ne suffisait pas — la
     page blanchissait quand même le temps du rendu.

     ➜ On ne navigue plus : on REMPLACE la section produit en place, via la
       Section Rendering API de Shopify (`?section_id=…`), et on réécrit l'URL
       avec history.pushState. Le client change de fiche sans quitter la page.

     ⚠️ innerHTML N'EXÉCUTE PAS LES <script>. Sans les recréer un par un, la
       nouvelle fiche arrive muette : plus de sélecteur de taille, plus de
       pack, plus d'ajout au panier. C'est le piège central de ce genre de
       remplacement, et il ne se voit pas au premier coup d'œil — la page a
       l'air juste.
     ⚠️ On garde le PRÉCHARGEMENT au survol : il sert toujours, la requête de
       section part alors avant le clic.
     ⚠️ Le bouton RETOUR du navigateur doit remarcher : popstate recharge la
       section correspondante au lieu de laisser une URL qui ment.
     ⚠️ Si quoi que ce soit échoue (réseau, section absente), on retombe sur
       une navigation normale — jamais d'écran mort. */
  (() => {
    const SECTION = document.currentScript?.closest('.shopify-section')
      || document.querySelector('[id^="shopify-section-"][id$="__main"]');
    if (!SECTION) return;
    const sectionId = SECTION.id.replace('shopify-section-', '');
    const cache = new Map();

    /* ⛔ LE FLASH AU CHANGEMENT DE CORORIS — TROUVÉ LE 30/08 À 02h20, PAR SON SCREEN.
       Il le signalait depuis le 29/08 : « quand je clique sur un coloris ça fait
       apparaître du HTML pendant une micro seconde ». J'avais cherché à côté (j'ai
       corrigé un prix qu'il n'avait jamais mentionné), puis filmé sans rien voir.
       Sa capture, prise PENDANT le flash, montrait le panneau d'avis déroulé en
       pleine page par-dessus la fiche.

       LA CAUSE, MESURÉE :
         · `<link rel="stylesheet" href="onix-product.css">` est écrit en TÊTE DE
           CETTE SECTION (l.9-10), donc il APPARTIENT à la section.
         · Un changement de coloris fait `courante.replaceWith(neuve)` : l'ancienne
           balise <link> part avec l'ancienne section, la neuve arrive avec la
           nouvelle. Il existe donc un instant où la page n'a plus sa feuille.
         · Or les modales (avis, guide des tailles, entretien) sont DANS LE DOM en
           permanence, en plein écran, cachées UNIQUEMENT par `opacity: 0` — donc
           uniquement par cette feuille.
       Mesure directe : feuille retirée, `[data-reviews-popup]` passe d'opacité 0 à
       1 et sa hauteur de 844 px à 16 445 px. Tout le contenu caché se déroule.

       ⚠️ POURQUOI ÇA NE SE VOYAIT PAS CHEZ MOI : la feuille était en cache, donc
         réappliquée dans la même frame. Lui était en NAVIGATION PRIVÉE avec les
         outils de développement ouverts — cache vide, rendu ralenti, fenêtre
         large. Un défaut invisible sur ma machine n'est pas un défaut absent.

       ➜ ON CLONE LA FEUILLE DANS <head>, ET ON NE RETIRE PAS L'ORIGINALE. Le clone
         porte la même URL : aucun téléchargement en plus, et surtout AUCUN moment
         sans style, ni maintenant ni pendant le clonage. Ensuite chaque section
         reçue arrive débarrassée de ses <link> (voir poser()), donc plus rien
         n'entre ni ne sort. La fenêtre sans style n'existe plus du tout. */
    const ancrerCss = () => {
      SECTION.querySelectorAll('link[rel="stylesheet"][href]').forEach((l) => {
        const deja = [...document.head.querySelectorAll('link[rel="stylesheet"][href]')]
          .some(h => h.href === l.href);
        if (deja) return;
        const clone = l.cloneNode(false);
        clone.setAttribute('data-onix-ancre', '');
        document.head.appendChild(clone);
      });
    };
    ancrerCss();

    /* ⛔ UNE PROMESSE REJETÉE NE RESTE PAS EN CACHE — 05/09, TROUVÉ PAR TEST,
       PAS PAR RELECTURE. La version d'avant mettait `p` dans le cache AVANT de
       savoir si elle aboutissait, et les écouteurs de préchargement étaient en
       `{ once: true }`. Conséquence, mesurée en injectant UN SEUL 503 au survol
       puis en rendant le réseau : le clic est parti en navigation COMPLÈTE
       (120 533 o et 218 ms de serveur, au lieu de 10 564 o et 87 ms), le
       contexte JS a été détruit et la position de défilement perdue. Et c'était
       définitif : `once` avait retiré l'écouteur, plus rien ne réessayait de la
       visite. J'ai déclenché moi-même des `429` en enchaînant les requêtes —
       un 429 au survol empoisonnait donc le lien pour toute la visite.
       ➜ L'entrée s'efface si la promesse échoue, et les écouteurs de survol ne
         sont plus `once` : le clic suivant refait simplement la requête.
       ⚠️ `cache.get(href) === p` avant de supprimer : sans ce test, un échec
         tardif effacerait l'entrée d'une requête ULTÉRIEURE qui, elle, a réussi. */
    const chercher = (href) => {
      if (cache.has(href)) return cache.get(href);
      const url = href.split('?')[0] + '?section_id=' + encodeURIComponent(sectionId);
      const p = fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(r => r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status)));
      cache.set(href, p);
      p.catch(() => { if (cache.get(href) === p) cache.delete(href); });
      return p;
    };

    /* ══ PRÉCHAUFFAGE DE L'IMAGE D'ARRIVÉE ══════════════════════════════════
       Mesuré le 05/09 : sur les 7 images de la section reçue, AUCUNE n'est déjà
       en cache au moment de l'échange (`imagesIdentiques: 0`). La photo du
       maillot d'arrivée arrivait donc APRÈS le remplacement — +29 ms sur fibre
       pour 47 ko, et c'est le seul poste que rien ne préchargeait. Sur un
       téléphone en 4G ce même poste est le trou visible de la transition : la
       galerie est déjà en place, vide, pendant que l'image descend.
       ⚠️ ON RECOPIE `sizes` ET `srcset` AVANT `src`, DANS CET ORDRE. Le
         navigateur choisit le candidat au moment où `srcset` est posé, en
         lisant le `sizes` déjà présent. Poser `src` d'abord téléchargerait la
         version 1600 px que la fiche n'affiche jamais — 4 fois le poids utile,
         et le vrai candidat resterait à télécharger.
       ⚠️ Une seule fois par fiche (`imgFaites`) : le survol se répète, le
         DOMParser coûte 1 à 2 ms, et l'image est déjà chaude au deuxième. */
    const imgFaites = new Set();
    const chaufferImage = (html, href) => {
      if (!html || imgFaites.has(href)) return;
      imgFaites.add(href);
      try {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const img = doc.querySelector('.onix-product__slide--hero img, .onix-product__slide img');
        const src = img && img.getAttribute('src');
        if (!src) return;
        const chaud = new Image();
        chaud.decoding = 'async';
        const sizes = img.getAttribute('sizes');
        const srcset = img.getAttribute('srcset');
        if (sizes) chaud.sizes = sizes;
        if (srcset) chaud.srcset = srcset;
        chaud.src = src;
      } catch (_) { /* un préchauffage ne casse jamais la page */ }
    };

    /* ══ PRÉCHARGEMENT DES FICHES SŒURS, À L'INACTIVITÉ ═════════════════════
       Chronométré le 05/09, même harnais avant/après : une section jamais
       demandée coûte 96 à 185 ms entre le clic et l'échange ; la même section
       déjà dans le `Map` coûte 12 à 32 ms. Deux régimes, pas une moyenne. Le
       survol ne rattrape que le premier régime SUR ORDINATEUR : sur téléphone
       il n'y a pas de survol, et `touchstart` part quelques dizaines de
       millisecondes avant le clic. ➜ On demande les sœurs AVANT, à l'inactivité.

       ⚠️ UNE SEULE FILE, SÉRIALISÉE, 350 ms D'ÉCART — et ce n'est pas de la
         prudence gratuite : Shopify m'a rendu des `429` le 05/09 en enchaînant
         les requêtes de section. La rangée de versions et la rangée de coloris
         se branchent toutes les deux au chargement ; sans file commune, elles
         partiraient ensemble.
       ⚠️ PAS DE `<link rel="prefetch">` SUR L'URL DE LA FICHE. Il téléchargerait
         le DOCUMENT ENTIER — 120 533 o mesurés contre 10 564 o pour la section —
         et il n'alimenterait PAS le `Map` que le clic interroge : le swap
         demande `?section_id=`, pas la page. On préchargerait 12 fois le poids
         utile pour ne rien accélérer du chemin réellement emprunté.
       ⚠️ BUDGET FERMÉ POUR LA VISITE : 6 sections et 3 images. `brancher` est
         rappelée après CHAQUE échange ; sans budget, une visite de dix
         changements de version ferait dix vagues de préchargement.
       ⚠️ ON NE PRÉCHARGE PAS SUR UN FORFAIT ÉCONOME NI EN 2G, et pas dans un
         onglet caché : c'est de la donnée dépensée d'avance pour un clic qui
         n'aura peut-être pas lieu. */
    const AVANCE = 3;          // sœurs mises en file par rangée
    let budgetSections = 6;    // requêtes de section pour toute la visite
    let budgetImages = 3;      // images de héros préchauffées d'avance
    const file = [];
    let enVol = false;

    const avare = () => {
      const c = navigator.connection;
      return !!(c && (c.saveData === true || /(^|-)2g$/.test(c.effectiveType || '')));
    };

    const pomper = () => {
      if (enVol || budgetSections <= 0) return;
      const href = file.shift();
      if (href === undefined) return;
      if (document.visibilityState !== 'visible') { file.unshift(href); return; }
      if (cache.has(href)) { pomper(); return; }
      budgetSections -= 1;
      enVol = true;
      chercher(href)
        .then((html) => { if (budgetImages > 0) { budgetImages -= 1; chaufferImage(html, href); } })
        .catch(() => {})
        .then(() => { enVol = false; setTimeout(pomper, 350); });
    };

    /* ⚠️ 1 500 ms, ET C'EST MESURÉ, PAS CHOISI. À 2 500 ms le premier
       préchargement partait à 10 232 ms du début du chargement : la rangée de
       versions est elle-même un aller-retour réseau, elle n'est branchée qu'à
       ~7,7 s sur cette fiche, et le délai d'inactivité s'ajoute APRÈS. Le
       compte à rebours court depuis l'appel, pas depuis le chargement — le
       raccourcir avance donc tout d'autant. À ce stade la page a fini de se
       charger, le préchargement ne prend la place de rien. */
    const aLoisir = (fn) => (window.requestIdleCallback
      ? window.requestIdleCallback(fn, { timeout: 1500 })
      : setTimeout(fn, 900));

    const enfiler = (racine) => {
      if (avare()) return;
      let n = 0;
      racine.querySelectorAll('a.onix-colors__item').forEach((a) => {
        if (n >= AVANCE || cache.has(a.href) || file.indexOf(a.href) >= 0) return;
        file.push(a.href);
        n += 1;
      });
      if (file.length) aLoisir(pomper);
    };

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') pomper();
    });

    /* ⚠️ ON NE REJOUE PLUS LES SCRIPTS — corrigé le 29/08 après sa capture.
       Les recréer un par un les ré-exécutait TOUS, y compris ceux qui ouvrent
       les modals « Guide taille » et « Entretien » : après un changement de
       coloris, les deux surgissaient par-dessus la fiche, et la galerie
       tombait à une seule photo. Mesuré : `if-modal` et `ent-modal` visibles,
       `.onix-product__slide` = 1 au lieu de 2. Zéro erreur en console — le
       genre de casse qui ne se voit qu'à l'œil.
       ➜ On réinitialise NOMMÉMENT ce qui doit l'être (le pack, les coloris) et
         on laisse le reste tranquille : ces scripts écoutent `document`, ils
         survivent au remplacement.
       ➜ Et on referme ce qui aurait pu s'ouvrir, par sécurité : un modal
         ouvert au retour d'un changement de couleur est pire que pas de
         transition du tout. */
    /* ⚠️ GLOBAL ET IDEMPOTENT, comme `__onixPack2` : le JS de section est
       extrait par Shopify dans un fichier chargé UNE fois, il ne se rejoue donc
       pas après un échange de section. C'est `reinitialiser()` qui le rappelle. */
    window.__onixVids = function () {
      document.querySelectorAll('[data-pdp-vids]').forEach((box) => {
        if (box.dataset.vidsPret === '1') return;
        box.dataset.vidsPret = '1';
        const piste = box.querySelector('[data-vids-piste]');
        if (!piste) return;
        const slides = [...box.querySelectorAll('[data-vids-slide]')];

        /* ⚠️ ON DÉMARRE SUR CELLE DU MILIEU. À scrollLeft = 0, la première vidéo
           est calée à gauche : rien ne dépasse de ce côté, et le carrousel se lit
           comme une image unique mal cadrée. En partant du milieu, le débord
           existe des DEUX côtés dès la première seconde — c'est ce qui dit qu'il
           y en a d'autres, sans écrire « 1 / 3 ».
           `behavior: auto` et pas `smooth` : un défilement animé au chargement
           serait un mouvement que personne n'a demandé. */
        if (slides.length > 2) {
          /* ⚠️ `scrollIntoView`, PAS un `scrollTo` calculé à la main. Mon premier
             essai posait `offsetLeft − (clientWidth − offsetWidth) / 2`, ce qui
             ignore le `scroll-padding: 0 14%` de la piste : les deux centrages se
             sont additionnés et le carrousel est parti trop loin — deux vidéos
             entières côte à côte au lieu d'une centrale et deux débords.
             Le navigateur, lui, connaît son propre padding. */
          /* ⛔ SURTOUT PAS `scrollIntoView` — 29/08, mesuré après coup.
             Il fait défiler TOUS les ancêtres scrollables, pas seulement la
             piste : le `<body>` s'est retrouvé à `scrollLeft = 247`, et la page
             ENTIÈRE — header compris — était décalée de 247 px vers la gauche.
             Le document ne débordait pourtant pas (`scrollWidth == clientWidth`),
             donc aucun garde de « hors écran » ne pouvait le voir.
             On écrit directement le `scrollLeft` de la piste : elle seule bouge. */
          const c2 = slides[Math.floor(slides.length / 2)];
          piste.scrollLeft = c2.offsetLeft - piste.offsetLeft - (piste.clientWidth - c2.offsetWidth) / 2;
        }

        const pas = (sens) => {
          const l = slides[0] ? slides[0].getBoundingClientRect().width + 12 : piste.clientWidth * 0.7;
          piste.scrollBy({ left: sens * l, behavior: 'smooth' });
        };
        box.querySelector('[data-vids-prev]')?.addEventListener('click', () => pas(-1));
        box.querySelector('[data-vids-next]')?.addEventListener('click', () => pas(1));

        /* Lecture/pause au clic. Une seule vidéo joue à la fois : trois vidéos
           simultanées sur un téléphone, c'est trois décodeurs et une page qui
           rame — et le client n'en regarde qu'une. */
        slides.forEach((s2) => {
          const v = s2.querySelector('video');
          const b2 = s2.querySelector('[data-vids-play]');
          if (!v || !b2) return;
          const bascule = () => {
            if (v.paused) {
              slides.forEach((o) => { const ov = o.querySelector('video'); if (ov && ov !== v) { ov.pause(); o.classList.remove('joue'); } });
              v.play().then(() => s2.classList.add('joue')).catch(() => {});
            } else { v.pause(); s2.classList.remove('joue'); }
          };
          b2.addEventListener('click', bascule);
          v.addEventListener('click', bascule);
          v.addEventListener('ended', () => s2.classList.remove('joue'));
        });
      });
    };

    const reinitialiser = () => {
      document.querySelectorAll('.if-modal, .ent-modal, [data-trust-overlay]').forEach(m => {
        m.removeAttribute('open');
        m.setAttribute('hidden', '');
        m.classList.remove('is-open', 'open');
      });
      /* ⛔ UNE SEULE LISTE, PLUS DEUX — 30/08, 03h15.
         Il y avait ICI une liste de cinq rappels, et une SECONDE dans
         `rejouerTout` plus bas, écrite un autre jour. Elles avaient déjà
         divergé : `__onixQuantite` ne figurait que dans la seconde. Mesuré, pas
         supposé — deux listes écrites à la main pour le même travail divergent
         toujours, la seule question est quand.
         Le commentaire précédent disait « LA LISTE COMPLÈTE, PAS CELLE DU
         JOUR ». Il était juste, et il n'a pas suffi : une consigne en prose ne
         tient pas une liste à jour.
         ➜ `rejouerTout` est désormais l'unique liste, et elle est appelée ici.
           Elle est définie plus bas dans le fichier, donc on la lit au moment de
           l'appel — jamais avant, sinon on retombe sur le TypeError qui avait
           tué toute une IIFE le 29/08.
         ⚠️ Les composants qui savent écouter `onix:product:swapped` eux-mêmes
           (onix-livraison.js) ne sont PAS dans cette liste, et c'est voulu : un
           composant autonome n'a besoin de l'accord de personne. */
      if (typeof window.__onixRejouerTout === 'function') window.__onixRejouerTout();
    };

    const poser = (html, href, pousser) => {
      const y0 = window.scrollY;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const neuve = doc.querySelector('#' + CSS.escape(SECTION.id)) || doc.body.firstElementChild;
      if (!neuve) throw new Error('section absente de la réponse');
      const courante = document.getElementById(SECTION.id);

      /* ⛔ LE TROU BLANC DE 320 ms — TROUVÉ LE 29/08, ET C'EST LUI QUI L'A VU.
         « regarde quand je clique sur un coloris y'a quoi qui s'affiche pendant
         une micro seconde ». Réponse mesurée, image par image : RIEN. Un trou.
         Toute la colonne d'achat porte `opacity: 0` + `onixProductFadeUp`, avec
         des délais échelonnés jusqu'à 0,32 s (onix-product.css l.214-248) —
         c'est l'animation d'ARRIVÉE DE PAGE. Le contenu injecté la rejoue
         intégralement : le bloc disparaît ~320 ms, puis revient en fondu.
         Filmé : blanc à 183 ms, blanc à 333 ms, fondu à 478 ms.
         ➜ La classe est posée AVANT l'insertion, donc avant la première
           peinture : sans ça, une image à opacity 0 passerait quand même.
           Le premier chargement, lui, garde son animation intacte.
         node scripts/filmer-interaction.js <url> ".onix-colors--mobile a.onix-colors__item" --zone ".onix-product__actions" */
      /* La feuille est déjà ancrée dans <head> (voir ancrerCss). Réinjecter la
         balise avec la section ne servirait qu'à la faire sortir et rentrer au
         prochain échange — c'est-à-dire à rouvrir la fenêtre sans style. */
      neuve.querySelectorAll('link[rel="stylesheet"]').forEach(l => l.remove());
      neuve.classList.add('est-echangee');
      /* le prix a sa propre animation en trois temps : on la déclare JOUÉE,
         sinon il rebarre son ancien prix à chaque coloris. */
      neuve.querySelectorAll('.onix-product__pricing').forEach(b => b.classList.add('est-pret', 'est-joue'));

      courante.replaceWith(neuve);
      reinitialiser();
      if (pousser) history.pushState({ onixColor: href }, '', href);
      document.title = (neuve.querySelector('.onix-product__title, h1')?.textContent || document.title).trim();
      /* ⚠️ ON NE REMONTE PAS EN HAUT — sa demande du 29/08 : « faut vraiment
         pas ressentir de changement ». Un scrollTo, même doux, EST le
         changement de page : c'est le seul mouvement que l'œil ne peut pas
         rater. On restitue la position exacte d'avant l'échange. */
      window.scrollTo(0, y0);
      document.dispatchEvent(new CustomEvent('onix:product:swapped', { bubbles: true }));
    };

    /* ⛔ IDEMPOTENTE — LE DOUBLE BRANCHEMENT DU 05/09, TROUVÉ EN RELISANT L'ORDRE
       DES APPELS. `poser()` appelle `reinitialiser()` AVANT de diffuser
       `onix:product:swapped` ; `reinitialiser()` rejoue `__onixVersions`, qui
       repose sa rangée depuis le cache et la branche par
       `__onixBrancherColoris(rangee)`. Puis l'événement part et le `brancher
       (document)` d'en dessous repasse sur CES MÊMES liens : deux écouteurs de
       clic, donc DEUX `poser()`, deux `pushState` — et un bouton retour qu'il
       faut presser deux fois pour revenir d'un cran. Rien ne l'aurait signalé :
       la page s'affiche correctement, elle est juste échangée deux fois.
       Le marqueur vit sur l'élément ; les liens sont recréés à chaque échange
       de section, donc il se remet à zéro tout seul. */
    const brancher = (racine) => {
      racine.querySelectorAll('a.onix-colors__item').forEach(a => {
        if (a.dataset.onixBranche === '1') return;
        a.dataset.onixBranche = '1';
        /* ⛔ PLUS DE `{ once: true }` — c'est la moitié du défaut du 05/09.
           Couplé au cache qui gardait les promesses rejetées, un seul échec
           réseau au survol condamnait le lien pour toute la visite : plus aucun
           écouteur pour réessayer, et le clic partait en navigation complète.
           Sans `once`, le survol répété ne coûte RIEN : `chercher` rend
           l'entrée du cache sans requête, et `chaufferImage` se protège par
           `imgFaites`. */
        const survoler = () => { chercher(a.href).then((h) => chaufferImage(h, a.href)).catch(() => {}); };
        a.addEventListener('mouseenter', survoler);
        a.addEventListener('touchstart', survoler, { passive: true });
        a.addEventListener('click', async (e) => {
          if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;   // ouvrir dans un onglet reste possible
          e.preventDefault();
          racine.querySelectorAll('.onix-colors__item').forEach(x => x.classList.remove('is-current'));
          a.classList.add('is-current', 'is-loading');
          try {
            /* ⚠️ PLUS DE startViewTransition — c'est le fondu global qui se
               VOYAIT : toute la page clignotait pour un changement de photo.
               Le remplacement direct est imperceptible quand la section est
               déjà en cache (préchargée au survol), et c'est le but. */
            poser(await chercher(a.href), a.href, true);
          } catch (_) {
            window.location.href = a.href;   /* repli : navigation normale */
          }
        });
      });
      /* ⚠️ APRÈS le branchement, et sur la MÊME racine : la rangée de versions
         est branchée à part (`__onixBrancherColoris(rangee)`), c'est donc le
         seul endroit d'où l'on voit ses liens sans les chercher une deuxième
         fois. La file est commune aux deux rangées ; le budget est commun à la
         visite. */
      enfiler(racine);
    };

    brancher(document);
    /* ⚠️ EXPOSÉE POUR LE SÉLECTEUR DE VERSIONS — 05/09, et c'est la SEULE ligne
       ajoutée à cette couche. La rangée « même équipe, même saison » arrive
       APRÈS le chargement (elle est demandée à une URL de collection filtrée par
       tag), donc après ce `brancher(document)`. Elle a besoin d'être branchée à
       son tour, et sur ELLE SEULE : rappeler `brancher(document)` reposerait un
       second écouteur de clic sur des liens déjà branchés, et un clic
       échangerait alors la section deux fois. Publier la fonction coûte une
       ligne ; la réécrire aurait coûté le préchargement, l'URL, le bouton
       retour et la position de défilement. */
    window.__onixBrancherColoris = brancher;
    document.addEventListener('onix:product:swapped', () => brancher(document));

    window.addEventListener('popstate', async () => {
      try { poser(await chercher(location.href), location.href, false); }
      catch (_) { window.location.reload(); }
    });
  })();

  /* ══ PACK 2 VESTES ══════════════════════════════════════════════════════
     Trois choses : le choix de la couleur, le choix de la TAILLE (qui se
     repeuple à chaque changement de couleur — les tailles disponibles ne sont
     pas les mêmes d'une veste à l'autre), et l'ajout des deux en un appel.

     ⚠️ LA TAILLE NE SE DEVINE PAS — sa correction du 29/08. La version d'hier
       reprenait en silence la taille choisie sur la fiche, et retombait sur la
       première variante si elle n'existait pas : le client se serait retrouvé
       avec une taille qu'il n'a jamais choisie. Elle se demande désormais, et
       le bouton refuse tant qu'elle n'est pas choisie.
     ⚠️ Une taille INDISPONIBLE reste affichée, barrée et désactivée : la
       masquer ferait croire que la veste n'existe pas dans cette taille.
     ⚠️ /cart/add.js prend les deux lignes en UN appel : deux appels laisseraient
       un panier à moitié rempli si le second échoue. */
  /* ⚠️ UNE FONCTION GLOBALE, PAS UNE IIFE — corrigé le 29/08, et c'est la
     découverte qui explique tout. Ce fichier place son JS dans un bloc
     `{% javascript %}` : Shopify l'EXTRAIT dans un fichier externe chargé UNE
     SEULE FOIS pour la page. Il ne se rejoue donc jamais quand on remplace la
     section — d'où un pack parfaitement rendu mais totalement muet après un
     changement de coloris : plus de tailles, plus de listeners, aucune erreur
     en console pour le signaler.
     ➜ L'initialisation est exposée en global et rappelée après chaque échange
       de section. Elle est IDEMPOTENTE : `dataset.pack2Pret` empêche de poser
       deux fois les mêmes écouteurs sur un bloc déjà branché. */
  window.__onixPack2 = function initPack2() {
    const box = document.querySelector('[data-pack2]');
    if (!box || box.dataset.pack2Pret === '1') return;
    box.dataset.pack2Pret = '1';

    const picks   = [...box.querySelectorAll('[data-pack2-pick]')];
    const zoneT   = box.querySelector('[data-pack2-taille]');
    const thumb   = box.querySelector('[data-pack2-thumb]');
    const nameEl  = box.querySelector('[data-pack2-name]');
    const amount  = box.querySelector('[data-pack2-amount]');
    const totalEl = box.querySelector('[data-pack2-total]');
    const btn     = box.querySelector('[data-pack2-add]');
    const note    = box.querySelector('[data-pack2-note]');
    const remise  = parseInt(box.dataset.remise || '20', 10);
    const prixMoi = window.__onixProductPrice || 0;
    let choix = box.querySelector('[data-pack2-pick].is-on') || picks[0];
    let taille = null;

    /* Le format monétaire du thème, repris d'un montant DÉJÀ rendu par Liquid
       plutôt que reconstruit — un format en dur est un piège documenté. */
    const modele = (totalEl && totalEl.textContent) || '0,00€';
    const fmt = (cents) => {
      const n = (cents / 100).toFixed(2).replace('.', ',');
      return modele.trim().startsWith('€') ? '€' + n : n + modele.replace(/[\d.,\s]/g, '');
    };

    function variantesDe(el) {
      return (el.dataset.variants || '').split('|').filter(Boolean).map(p => {
        const [id, titre, dispo] = p.split('~');
        return { id, titre, dispo: dispo === '1' };
      });
    }

    /* ⛔ LA TAILLE VIENT DU HAUT, ELLE NE SE REDEMANDE PLUS — 29/08.
       Avant : une rangée de boutons S/M/L/XL/2XL dans le pack, indépendante de
       celle de la fiche. Le client choisissait donc DEUX fois, et repartait
       avec un M et un S sans l'avoir voulu.
       Maintenant : on lit la taille sélectionnée au-dessus et on résout la
       variante correspondante chez la deuxième veste.
       ⚠️ Le nom de taille est comparé en minuscules et sur le PREMIER mot :
         le thème écrit « L » dans le bouton mais la variante peut s'appeler
         « L / Noir ». Une comparaison stricte échouerait en silence — et une
         résolution qui échoue en silence, c'est exactement le bug d'avant.
       ⚠️ Si la 2ᵉ veste n'a pas cette taille, on le DIT au lieu d'en choisir
         une autre : proposer un pack dans une taille que le client n'a pas
         demandée est pire que de ne pas le proposer. */
    function tailleDuHaut() {
      const b = document.querySelector('.onix-product__size-button.is-selected')
        || document.querySelector('.onix-product__sizes [aria-pressed="true"], .onix-product__sizes [aria-checked="true"]');
      return b ? (b.textContent || '').trim().split(/\s+/)[0].toLowerCase() : null;
    }

    function synchroniserTaille() {
      taille = null;
      const voulue = tailleDuHaut();
      const vars = variantesDe(choix);
      if (!voulue) {
        zoneT.hidden = true;
        return;
      }
      const v = vars.find(x => String(x.titre || '').trim().split(/\s+/)[0].toLowerCase() === voulue);
      zoneT.hidden = false;
      if (!v) {
        zoneT.textContent = (zoneT.dataset.tAbsente || 'Taille @@ indisponible sur ce coloris')
          .replace('@@', voulue.toUpperCase());
        zoneT.classList.add('is-ko');
        return;
      }
      zoneT.classList.toggle('is-ko', !v.dispo);
      if (!v.dispo) {
        zoneT.textContent = (zoneT.dataset.tRupture || 'Taille @@ en rupture sur ce coloris')
          .replace('@@', voulue.toUpperCase());
        return;
      }
      taille = v.id;
      zoneT.textContent = (zoneT.dataset.tMeme || 'Les deux en taille @@')
        .replace('@@', voulue.toUpperCase());
      note.hidden = true;
    }
    const peuplerTailles = synchroniserTaille;   /* les appels existants restent valides */

    function poser(el) {
      choix = el;
      picks.forEach(p => { p.classList.toggle('is-on', p === el); p.setAttribute('aria-pressed', p === el ? 'true' : 'false'); });
      if (thumb) thumb.innerHTML = '<img src="' + el.dataset.img + '" alt="" loading="eager">';
      if (nameEl) nameEl.textContent = el.dataset.title;
      const duo = prixMoi + parseInt(el.dataset.price || '0', 10);
      if (duo) {
        const total = Math.round(duo * (100 - remise) / 100);
        if (totalEl) totalEl.textContent = fmt(total);
        const was = box.querySelector('[data-pack2-was]');
        if (was) was.textContent = fmt(duo);
        /* La 2ᵉ ligne porte toute la remise : total moins le prix de la 1re. */
        if (amount) amount.textContent = fmt(total - prixMoi);
        const wasLigne = box.querySelector('[data-pack2-amount-was]');
        if (wasLigne) wasLigne.textContent = el.dataset.priceFmt;
      }
      peuplerTailles();
    }

    picks.forEach(p => p.addEventListener('click', () => poser(p)));
    peuplerTailles();

    /* ⛔ LA TAILLE DU HAUT SE SUIT, ELLE NE SE LIT PAS UNE FOIS — 29/08.
       `peuplerTailles()` ne tournait qu'au chargement du bloc, donc AVANT que le
       client ait choisi sa taille. Mesuré : taille du haut « L », taille du pack
       « S ». Il repartait donc avec deux vestes de tailles différentes sans
       jamais l'avoir demandé — « pourquoi les 2 vestes c'est pas la même taille
       alors que je les ai pris ensemble ? ».
       ⚠️ Elle est SUIVIE, pas imposée : le client garde le droit de prendre deux
         tailles différentes (une pour lui, une pour quelqu'un d'autre). On
         n'écrase donc que tant qu'il n'a pas touché aux tailles du pack. */
    /* La taille du pack SUIT désormais celle du haut, sans exception : il n'y a
       plus de choix concurrent à préserver. */
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.onix-product__size-button')) return;
      setTimeout(synchroniserTaille, 60);   /* le thème pose `is-selected` après son propre handler */
    }, true);

    btn.addEventListener('click', async () => {
      const idMoi = document.querySelector('.onix-product [name="id"]')?.value;
      if (!taille) {
        note.hidden = false;
        note.textContent = 'Choisis d\'abord ta taille plus haut.';
        return;
      }
      if (!idMoi) {
        note.hidden = false;
        note.textContent = 'Choisis d\'abord ta taille plus haut.';
        return;
      }
      btn.disabled = true;
      const avant = btn.textContent;
      btn.textContent = 'Ajout…';
      try {
        const refPack = 'duo-' + Date.now().toString(36);
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          /* ⚠️ LES DEUX LIGNES SONT MARQUÉES — 29/08, sa demande : « dans le
             panier faut que le prix soit cohérent, fais un design spécial, en
             gros c'est différent que si on ajoutait les 2 individuellement ».
             Sans marque, le tiroir affiche deux vestes à 50,99 € et 51,00 € :
             la remise de 15 % répartie par Shopify sur chaque ligne, avec le
             centime de reste. Deux prix qui ne ressemblent ni à 59,99 ni à
             42,00, et rien qui dise que c'est un pack.
             Le `_` initial rend la propriété INVISIBLE au client sur la page
             panier et dans les e-mails — c'est la convention Shopify.
             ⚠️ Et surtout PAS `_offer_bundle` : cette clé-là déclenche toute
               la mécanique de l'offre découverte (quantité verrouillée,
               exclusion des paliers). Les deux offres ne se relient jamais. */
          /* ⛔ UN IDENTIFIANT PAR PACK, PAS UNE ÉTIQUETTE COMMUNE — 29/08, 18h.
             Avec la valeur fixe « duo », deux packs ajoutés l'un après l'autre
             portaient la même marque : le tiroir les regroupait dans UNE carte
             intitulée « PACK 2 VESTES » contenant quatre vestes. Sa remarque :
             « dans le panier je me retrouve avec 3 vestes, c'est pas normal ».
             Un identifiant unique par ajout donne une carte par pack.
             ⚠️ Effet de bord VOULU : Shopify ne fusionne plus deux packs
               identiques en une ligne × 2, puisque leurs propriétés diffèrent.
               C'est ce qu'on veut — deux packs sont deux offres, pas une ligne
               de quantité 2 dont on ne saurait plus dire quelle remise couvre quoi. */
          body: JSON.stringify({ items: [
            { id: idMoi,  quantity: 1, properties: { _pack_veste: refPack } },
            { id: taille, quantity: 1, properties: { _pack_veste: refPack } }
          ] })
        });
        if (!r.ok) throw new Error(await r.text());

        /* ⚠️ LE CODE S'APPLIQUE ICI, SINON LE PRIX AFFICHÉ EST UN MENSONGE.
           Le bloc annonce un total remisé ; sans cette ligne la caisse facture
           le plein tarif, et le client le découvre au paiement. Mesuré le 29/08
           avant correction : 95,99 € affichés, 119,98 € en caisse, 0 € de remise.
           `/discount/<code>` pose le cookie de réduction côté Shopify ; le
           `redirect` vers /cart.js évite de télécharger une page entière.
           Un échec ici n'annule PAS l'ajout : le panier reste bon, il manque
           juste la remise — et le client peut encore taper le code à la main. */
        const code = box.dataset.code;
        if (code) {
          try { await fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js',
                            { credentials: 'same-origin' }); }
          catch (_) { /* le panier est déjà bon, on n'annule rien */ }
        }
        /* ⚠️ LE TIROIR S'OUVRE PAR LE PONT DU THÈME, pas par un événement
           inventé — sa remarque du 29/08 : « ça ouvre pas le panier ».
           J'avais émis `onix:cart:open`, un nom que RIEN n'écoute : l'ajout
           marchait, le tiroir restait fermé, et aucune erreur ne le disait.
           Le thème expose `window.__onixOpenDrawer` (déclaré dans
           cart-drawer.js, documenté dans cart-drawer-quickadd.js) — c'est le
           même pont que le « + » des cartes produit.
           `cart:refresh` reste émis AVANT : le tiroir doit s'ouvrir sur un
           contenu déjà rafraîchi, sinon il montre l'état d'avant l'ajout.
           Et si le pont n'existe pas (chargement partiel), on retombe sur la
           page panier plutôt que de ne rien faire. */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        await new Promise(r2 => setTimeout(r2, 120));
        if (typeof window.__onixOpenDrawer === 'function') window.__onixOpenDrawer();
        else if (typeof window.__onixRefreshCart === 'function') { window.__onixRefreshCart(); window.location.href = '/cart'; }
        else window.location.href = '/cart';
        btn.textContent = 'Ajouté ✓';
        setTimeout(() => { btn.textContent = avant; btn.disabled = false; }, 1800);
      } catch (e) {
        note.hidden = false;
        note.textContent = 'Ajout impossible — réessaie.';
        btn.textContent = avant;
        btn.disabled = false;
      }
    });
  };
  /* ══ LES VERSIONS DU MAILLOT — MÊME ÉQUIPE, MÊME SAISON ═════════════════
     Sa décision du 05/09. Trois choses, et deux d'entre elles sont des reprises.

     1. LA RANGÉE EST DEMANDÉE, PAS CALCULÉE. Liquid ne sait pas lister les
        produits portant un tag depuis une page produit : pas de collection par
        équipe, pas de metafield, et `collection.products` s'arrête à 50 sans
        `paginate`. La famille se demande donc à l'URL de collection filtrée par
        tag (`/collections/all/<tag>?view=versions`), qui rend UN fragment.
        ⚠️ Et surtout PAS `?section_id=` : Shopify écrit que l'identifiant de
          section « must exist in the template that renders for the URL you
          request […] it doesn't work against a collection or search URL ».

     2. LE SWAP N'EST PAS RÉÉCRIT. Les liens émis portent `onix-colors__item`,
        et on rappelle `brancher` sur la seule rangée. Préchargement au survol,
        remplacement de section, URL, bouton retour, position de défilement :
        tout vient de la couche du 29/08, telle quelle.

     3. LA TAILLE ET LE FLOCAGE SUIVENT LE CLIENT. Sans ça, changer de version
        vide en silence trois champs qu'il vient de remplir — le remplacement de
        section reconstruit le formulaire à neuf.
        ⚠️ LE FLOCAGE SE REPREND TOUJOURS : c'est du texte, il est valable sur
          n'importe quel maillot.
        ⚠️ LA TAILLE NE SE REPREND QUE SI ELLE EXISTE ET EST DISPONIBLE sur la
          version d'arrivée. Sinon on ne choisit RIEN à sa place et on le DIT en
          rouge. C'est la leçon du pack 2 vestes du 29/08 : « la taille ne se
          devine pas » — la version d'hier reprenait la taille en silence et
          retombait sur la première variante, et le client repartait avec une
          taille qu'il n'avait jamais choisie.

     ⚠️ `sessionStorage` PLUTÔT QU'UNE VARIABLE : les frères d'un maillot
       partagent le même tag de famille, donc la même rangée. Une fois demandée,
       elle ne l'est plus jamais de la visite — y compris après un changement de
       version, où elle se repose instantanément et où aucune case grise
       n'apparaît. Chaque accès est sous `try` : en navigation privée, lire
       `sessionStorage` LÈVE au lieu de rendre null. */
  const versionsChoix = () => {
    const floc = {};
    document.querySelectorAll('[data-floc-src]').forEach((champ) => {
      if (champ.value) floc[champ.dataset.flocSrc] = champ.value;
    });
    const btn = document.querySelector('.onix-product__size-button.is-selected');
    return { taille: btn ? (btn.dataset.sizeValue || '') : '', floc: floc };
  };

  /* ⛔ LA PHRASE SE COMPOSE DE CE QUI S'EST PASSÉ, JAMAIS DE CE QU'ON VOULAIT —
     05/09. La version d'avant tenait deux phrases toutes faites et en sortait
     une DÈS QU'ELLE AVAIT ESSAYÉ quelque chose. Elle mentait donc deux fois :
       · flocage rempli, aucune taille choisie ⇒ « ta taille et ton flocage sont
         gardés » — il n'y avait pas de taille ;
       · maillot d'arrivée tagué `sans-flocage` ⇒ ses champs n'existent pas, la
         boucle ne les trouvait pas, passait son chemin SANS RIEN DIRE, et la
         phrase jurait quand même que le flocage était gardé. Le client repartait
         sans le nom qu'il venait de taper, rassuré par une ligne fausse.
     ➜ On COMPTE ce qui a réellement été reposé, et on n'affirme que ça. */
  const versionsReposer = (repris) => {
    const voulus = Object.keys(repris.floc);
    let flocRepris = 0;
    voulus.forEach((k) => {
      const champ = document.querySelector('[data-floc-src="' + k + '"]');
      if (!champ) return;
      champ.value = repris.floc[k];
      /* l'aperçu du dos (`[data-floc-nom]`) écoute `input` : sans l'événement,
         les champs sont remplis et le maillot dessiné reste vide. */
      champ.dispatchEvent(new Event('input', { bubbles: true }));
      flocRepris += 1;
    });
    const note = document.querySelector('[data-versions-garde]');
    if (!note) return;
    const d = note.dataset;
    const gardes = [];
    const pertes = [];

    if (repris.taille) {
      const cible = [...document.querySelectorAll('[data-size-button]')]
        .find((b) => b.dataset.sizeValue === repris.taille);
      const dispo = !!cible && !cible.disabled && cible.dataset.variantAvailable === 'true';
      if (dispo) {
        /* on CLIQUE le bouton au lieu de recopier son état : le thème a déjà
           tout un handler derrière (variante cachée, prix, bouton d'ajout,
           barre collante). Le rejouer à la main, c'est le refaire diverger. */
        cible.click();
        gardes.push('taille');
      } else {
        pertes.push((d.perdue || '').replace('__T__', repris.taille));
      }
    }
    if (voulus.length) {
      if (flocRepris > 0) gardes.push('floc');
      else pertes.push(d.flocPerdu || '');
    }

    /* Rien saisi, rien à dire : la ligne reste cachée plutôt que de meubler. */
    if (gardes.length === 0 && pertes.length === 0) { note.hidden = true; return; }
    const phrases = [];
    if (gardes.length === 2) phrases.push(d.gardee || '');
    else if (gardes[0] === 'taille') phrases.push(d.gardeeTaille || '');
    else if (gardes[0] === 'floc') phrases.push(d.gardeeFloc || '');
    pertes.forEach((p) => phrases.push(p));
    note.hidden = false;
    /* une seule perte suffit à faire passer la ligne en rouge : c'est la partie
       que le client doit relire, pas celle qui s'est bien passée. */
    note.classList.toggle('est-alerte', pertes.length > 0);
    note.textContent = phrases.filter(Boolean).join(' ');
  };

  /* ⚠️ GLOBALE ET IDEMPOTENTE, comme `__onixPack2` : le JS de section est
     extrait par Shopify dans un fichier chargé UNE fois, il ne se rejoue donc
     pas après un échange de section. C'est `rejouerTout()` qui la rappelle, et
     `dataset.versionsPret` empêche de brancher deux fois le même bloc. */
  window.__onixVersions = function initVersions() {
    /* L'écouteur de reprise vit sur `document` et ne se pose qu'UNE fois : il
       travaille précisément pendant le remplacement de section, donc il ne peut
       pas vivre dans le bloc qui est remplacé. */
    if (!window.__onixVersionsEcoute) {
      window.__onixVersionsEcoute = true;
      document.addEventListener('onix:product:swapped', () => {
        const repris = window.__onixVersionsReprise;
        window.__onixVersionsReprise = null;
        /* une frame d'attente : `poser()` appelle `reinitialiser()` — donc
           `rejouerTout`, donc le recâblage des tailles — AVANT de diffuser
           l'événement, mais un autre écouteur enregistré avant celui-ci peut
           encore travailler sur le même tour. */
        if (repris) requestAnimationFrame(() => versionsReposer(repris));
      });
    }

    const boite = document.querySelector('[data-onix-versions]');
    if (!boite || boite.dataset.versionsPret === '1') return;
    boite.dataset.versionsPret = '1';
    const rangee = boite.querySelector('[data-versions-row]');
    if (!rangee || !boite.dataset.source) { boite.remove(); return; }
    const cle = 'onix:versions:' + (boite.dataset.cle || '');

    const lire = (k) => { try { return sessionStorage.getItem(k); } catch (_) { return null; } };
    const ecrire = (k, v) => { try { sessionStorage.setItem(k, v); } catch (_) { /* navigation privée */ } };

    const poser = (html) => {
      rangee.innerHTML = html;
      /* Une famille à un seul membre, un tag pas encore posé, une redirection :
         dans les trois cas le fragment est VIDE et le bloc s'efface. Une rangée
         d'une seule vignette — celle de la page où l'on est déjà — ne donne
         aucun choix, et une rangée vide sous un titre est un défaut visible. */
      if (!rangee.querySelector('.onix-versions__cell')) { boite.remove(); return; }
      /* La version où l'on est déjà cesse d'être un lien, exactement comme le
         fait le sélecteur de coloris : rien à charger, et la vignette dit où
         l'on est. Elle est marquée ICI et pas dans le fragment parce que le
         fragment est partagé par toute la famille — c'est ce partage qui permet
         de ne le demander qu'une fois pour six fiches. */
      /* ⛔ `data-ici`, PAS `window.location` — le défaut du 05/09. `poser()` du
         swap appelle `reinitialiser()` AVANT `history.pushState`, donc au
         moment où cette ligne s'exécute l'URL de la page est encore CELLE QU'ON
         VIENT DE QUITTER : l'anneau serait resté sur le Domicile après un clic
         sur l'Extérieur. `data-ici` est écrit par Liquid dans la section
         D'ARRIVÉE, il ne peut pas être en retard. Le repli sur `location` ne
         sert qu'au cas où l'attribut manque.
         ⚠️ ELLE S'APPELLE `cheminIci` ET SÛREMENT PAS `ici` — le banc l'a
           attrapé, ma relecture non. Le `span` construit deux lignes plus bas
           s'appelait déjà `ici` : un `const ici` extérieur est MASQUÉ par le
           `const ici` intérieur sur toute la portée du callback, zone morte
           comprise, et `a.pathname !== ici` levait un ReferenceError à chaque
           passage. `node --check` compile ce fichier sans broncher — c'est
           exactement la panne du 29/08 : la syntaxe est bonne, le code ne
           tourne pas. Six cas sur six en rouge au premier lancement. */
      const cheminIci = (boite.dataset.ici || window.location.pathname).split('?')[0].split('#')[0];
      rangee.querySelectorAll('a.onix-colors__item').forEach((a) => {
        if (a.pathname !== cheminIci) return;
        const ici = document.createElement('span');
        ici.className = a.className + ' is-current';
        ici.setAttribute('aria-current', 'true');
        ici.title = a.title;
        ici.innerHTML = a.innerHTML;
        a.replaceWith(ici);
      });
      rangee.removeAttribute('aria-busy');
      boite.classList.remove('est-attente');
      if (typeof window.__onixBrancherColoris === 'function') window.__onixBrancherColoris(rangee);
      /* En CAPTURE et sur la rangée, pas sur chaque lien : un écouteur de
         capture posé sur un ancêtre passe AVANT ceux de la cible, donc avant
         celui du swap. On lit ce que le client a saisi pendant que le
         formulaire est encore celui de cette page. */
      rangee.addEventListener('click', (e) => {
        const lien = e.target && e.target.closest ? e.target.closest('a.onix-colors__item') : null;
        if (!lien) return;
        window.__onixVersionsReprise = versionsChoix();
      }, true);
    };

    const enCache = lire(cle);
    if (enCache !== null) { poser(enCache); return; }

    fetch(boite.dataset.source, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error('HTTP ' + r.status))))
      .then((html) => { const net = html.trim(); ecrire(cle, net); poser(net); })
      .catch(() => { boite.remove(); });
  };

  /* ⛔ TOUJOURS SOUS `typeof`, ET APPELÉES À LA FIN DU FICHIER — 29/08, 18h.
     Une assignation `window.x = function(){}` n'est PAS hoistée : appeler
     `window.__onixMiniatures()` depuis une IIFE placée AVANT sa définition lève
     un TypeError. Et cette exception a tué l'IIFE ENTIÈRE — c'est ainsi que
     `__onixTailles`, définie plus bas dans le même bloc, n'a jamais été posée,
     et que la sélection de taille est retombée en panne alors que je venais de
     la réparer.
     ⚠️ Une erreur d'exécution dans un fichier qui COMPILE : `node --check` passe,
       le script ne fait rien. C'est pourquoi la vérification de syntaxe ne
       suffit pas — il faut regarder l'état du DOM après chargement. */
  /* ⚠️ L'UNIQUE LISTE DE REJEU DE CETTE SECTION — 30/08.
       `poser()` l'appelait autrefois avec sa PROPRE copie de cinq noms ; les deux
       avaient divergé (`__onixQuantite` manquait d'un côté). Elle est maintenant
       exposée sur `window` et appelée des deux endroits. Un seul endroit à tenir
       à jour, donc un seul endroit qui peut être oublié — au lieu de deux qui se
       contredisent en silence. */
  const rejouerTout = () => {
    ['__onixTailles', '__onixQuantite', '__onixPack2', '__onixVids', '__onixMiniatures', '__onixFleches', '__onixVersions']
      .forEach((f) => { if (typeof window[f] === 'function') window[f](); });
  };
  window.__onixRejouerTout = rejouerTout;
  rejouerTout();
  document.addEventListener('onix:product:swapped', rejouerTout);

  /* ── Trust popup modals ── */
  (() => {
    const trustData = {
      payment: {
        icon: '<svg viewBox="0 0 32 32" role="presentation"><rect x="7" y="14" width="18" height="11" rx="2" fill="none" stroke="currentColor" stroke-width="1.5"/><path d="M11 14V11a5 5 0 0 1 10 0v3" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
        title: document.querySelector('[data-trust-popup="payment"] strong')?.textContent?.trim() || '',
        text: document.querySelector('[data-trust-popup="payment"]')?.closest('.onix-product__content')?.querySelector('.onix-product__trust')?.dataset?.paymentText || 'Paiement protégé sur chaque commande.'
      },
      shipping: {
        icon: '<svg viewBox="0 0 32 32" role="presentation"><path d="M5 21h17l3-7H10" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="11" cy="24" r="2" fill="none" stroke="currentColor" stroke-width="1.5"/><circle cx="23" cy="24" r="2" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
        title: document.querySelector('[data-trust-popup="shipping"] strong')?.textContent?.trim() || '',
        text: document.querySelector('.onix-product__trust')?.dataset?.shippingText || 'Expédition rapide avec livraison suivie.'
      },
      returns: {
        icon: '<svg viewBox="0 0 32 32" role="presentation"><path d="M8 16h16M16 8l8 8-8 8" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>',
        title: document.querySelector('[data-trust-popup="returns"] strong')?.textContent?.trim() || '',
        text: document.querySelector('.onix-product__trust')?.dataset?.returnsText || 'Assurance livraison incluse sur chaque commande.'
      }
    };

    const overlay = document.querySelector('[data-trust-overlay]');
    if (!overlay) return;

    const iconWrap = overlay.querySelector('[data-trust-modal-icon]');
    const titleEl = overlay.querySelector('[data-trust-modal-title]');
    const textEl = overlay.querySelector('[data-trust-modal-text]');
    const closeBtn = overlay.querySelector('[data-trust-close]');

    function openModal(key) {
      const d = trustData[key];
      if (!d) return;
      iconWrap.innerHTML = d.icon;
      titleEl.textContent = d.title;
      textEl.textContent = d.text;
      overlay.style.display = 'flex';
    }

    function closeModal() {
      overlay.style.display = 'none';
    }

    document.querySelectorAll('[data-trust-popup]').forEach(btn => {
      btn.addEventListener('click', () => openModal(btn.dataset.trustPopup));
    });

    closeBtn?.addEventListener('click', closeModal);
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) closeModal();
    });
  })();

  (() => {
    // Rebuild marker for Shopify compiled section script bundle.
    let productSection = document.querySelector('.onix-product');
    if (!productSection) return;

    const mainFormId = productSection.dataset.mainProductFormId || '';
    const sizeOptionIndex = Number(productSection.dataset.sizeOptionIndex || 0);
    const soldOutLabel = productSection.dataset.soldOutLabel || 'Sold out';
    let mainForm = mainFormId ? document.getElementById(mainFormId) : null;
    const variantsJsonNode = productSection.querySelector('[data-product-variants-json]');
    let variants = variantsJsonNode ? JSON.parse(variantsJsonNode.textContent || '[]') : [];

    if (!mainForm) return;

    let submitButton = mainForm.querySelector('[data-product-submit]');
    /* ⚠️ IL N'Y A PAS DE SECOND FORMULAIRE : la barre collante soumet le
       formulaire PRINCIPAL par son attribut `form=`, elle ne vit donc dans
       aucun `stickyForm`. Le `stickyForm.querySelector('.onix-sticky-cart__
       button')` qui était ici rendait TOUJOURS null — et le libellé singulier
       qu'il captait au chargement servait ensuite de source concurrente à
       `getAddLabel()`. La barre se cherche là où elle est : `[data-sticky-add]`,
       dans le document. */
    let variantIdInput = mainForm.querySelector('[data-selected-variant-input]');
    let variantSelect = mainForm.querySelector('select[name="id"]');
    /* ⛔ UNE FONCTION, PAS UNE LISTE FIGÉE — 29/08, la vraie cause du bug.
       `mainForm.querySelectorAll(...)` rend une NodeList capturée une fois, au
       chargement. Après un échange de section, elle pointe sur des boutons
       DÉTRUITS : `setSelectedSizeButton()` posait donc `is-selected` sur des
       éléments qui ne sont plus dans le document, et l'utilisateur voyait le
       focus bouger sans que la sélection suive.
       ⚠️ J'ai d'abord recâblé les écouteurs, puis relu `variants` — les deux
         étaient nécessaires mais ne suffisaient pas. Le défaut avait TROIS
         causes empilées, et corriger les deux premières ne changeait rien de
         visible. C'est ce qui rend ce genre de bug si long : chaque correction
         juste laisse le symptôme intact.
       ➜ Tout ce qui vise le DOM d'une section échangeable se relit au moment
         de s'en servir. Une référence gardée est une référence périmée. */
    const sizeButtons = () => document.querySelectorAll('[data-size-button]');

    /* Écrit le libellé SANS toucher au reste du bouton (l'icône panier). */
    const poserLabel = (btn, txt) => {
      if (!btn) return;
      const cible = btn.querySelector('[data-submit-label], [data-sticky-label]');
      if (cible) cible.textContent = txt; else btn.textContent = txt;
    };
    const lireLabel = (btn) => {
      if (!btn) return '';
      const cible = btn.querySelector('[data-submit-label], [data-sticky-label]');
      return (cible || btn).textContent.trim();
    };
    const addToCartLabel = lireLabel(submitButton);

    /* Label CTA dynamique : « Ajouter mon maillot » (qté 1) / « Ajouter mes maillots » (qté > 1). */
    const addLabelSingular = productSection.dataset.addLabel || addToCartLabel;
    const addLabelPlural = productSection.dataset.addLabelPlural || addLabelSingular;
    const qtyInput = mainForm.querySelector('[data-qty-input]');
    const getAddLabel = () => {
      const q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return (!isNaN(q) && q > 1) ? addLabelPlural : addLabelSingular;
    };
    /* Klarna dynamique : « 4× 6,25€ » suit la QUANTITÉ (qté 2 → 4× 12,50€).
       Format aligné sur | money : EUR = « 12,50€ », autres devises = Intl
       narrowSymbol (même règle que le reste du thème). */
    const klarnaEl = productSection.querySelector('[data-klarna-amount]');
    const refreshKlarna = () => {
      if (!klarnaEl) return;
      const unitCents = parseInt(klarnaEl.dataset.unitCents, 10) || 0;
      const n = parseInt(klarnaEl.dataset.n, 10) || 4;
      const q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      if (!unitCents) return;
      const amount = Math.round(unitCents * q / n) / 100;
      const cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      let txt;
      if (cur === 'EUR') txt = amount.toFixed(2).replace('.', ',') + '€';
      else {
        try { txt = new Intl.NumberFormat('en', { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(amount); }
        catch (e) { txt = amount.toFixed(2) + ' ' + cur; }
      }
      klarnaEl.textContent = txt;
    };
    /* ─── UN SEUL POINT DE VÉRITÉ POUR CE QUE LES BOUTONS D'ACHAT ANNONCENT ──
       Il y en avait DEUX, et ils ne couvraient pas les mêmes boutons :
        · `refreshAddLabel`, branché sur les seuls +/− de la quantité, ne
          touchait que le bouton principal ;
        · `setSelectionState`, qui recale la barre collante, ne part qu'au
          changement de TAILLE.
       Résultat mesuré le 23/08, qté 1 → 4 : le bouton principal passait bien à
       « Ajouter mes maillots au panier » pendant que la barre restait sur
       « Ajouter mon maillot au panier » aux quatre crans — et ne se corrigeait
       qu'en retouchant la taille. Les deux boutons passent donc désormais par
       la même fonction, et tout ce qui bouge la quantité l'appelle. */
    const boutonsAchat = () => [
      submitButton,
      document.querySelector('[data-sticky-add]'),
    ].filter(Boolean);

    /* Le multiplicateur des lignes de prix (bouton ET barre) : vide à qté 1,
       « 4 × » au-delà. Le prix reste UNITAIRE — voir le commentaire du balisage,
       le total dépend d'un code de palier posé plus tard dans le tiroir.
       ⚠️ L'ESPACE ENTRE LE NOMBRE ET LE « × » EST INSÉCABLE, et elle est
          ÉCRITE EN ESCAPE (\u00a0) plutôt que tapée : à la lecture une insécable
          ne se distingue pas d'une espace ordinaire, donc elle se perd au
          premier repassage sur la ligne. Elle est nécessaire — dans la barre
          collante la ligne de prix s'enroule dans 77 px (mesuré), et un « 4 »
          resté seul en fin de ligne au-dessus de « × 24,99 € » annoncerait un
          tout autre prix. */
    const poserMultiplicateur = () => {
      const q = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
      /* Épuisé : on ne chiffre pas une quantité qu'on ne peut pas acheter —
         même raison que la ligne de prix qu'on masque plus bas. La barre
         collante, elle, ne masque pas son prix : sans ce test elle afficherait
         « 4 × 24,99 € » à côté d'un bouton « Indisponible ». */
      const epuise = lireLabel(submitButton) === soldOutLabel;
      document.querySelectorAll('[data-submit-qte]').forEach((el) => {
        el.textContent = (q > 1 && !epuise) ? q + '\u00a0×' : '';
        el.hidden = q <= 1 || epuise;
      });
    };

    const rafraichirAchat = () => {
      const txt = getAddLabel();
      boutonsAchat().forEach((btn) => {
        /* « Épuisé » n'est pas un libellé d'achat : on ne l'écrase pas.
           Le test porte sur le TEXTE affiché, pas sur `disabled` — un bouton
           peut être désactivé simplement parce qu'aucune taille n'est encore
           choisie, et il doit quand même suivre la quantité. */
        if (lireLabel(btn) === soldOutLabel) return;
        poserLabel(btn, txt);
      });
      poserMultiplicateur();
      refreshKlarna();
    };

    /* ⛔ LA QUANTITÉ SE RECÂBLE AUSSI — 29/08, 18h. Sixième composant touché par
       le même piège : `qtyInput` et ses deux boutons étaient capturés une fois,
       et après un échange de section les « − » et « + » du contenu neuf
       n'écoutaient plus rien. Le compteur restait bloqué sur 1.
       On en fait une fonction rappelée comme les cinq autres. */
    window.__onixQuantite = function () {
    const qtyInput = document.querySelector('[data-qty-input]');
    if (qtyInput && qtyInput.dataset.qteCablee !== '1') {
      qtyInput.dataset.qteCablee = '1';
      const qtyMinus = document.querySelector('[data-qty-minus]');
      const qtyPlus = document.querySelector('[data-qty-plus]');
      const qtyMax = parseInt(qtyInput.max, 10) || 99;
      const clampQty = () => {
        let v = parseInt(qtyInput.value, 10);
        if (isNaN(v) || v < 1) v = 1;
        if (v > qtyMax) v = qtyMax;
        qtyInput.value = v;
      };
      if (qtyMinus) qtyMinus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) - 1; clampQty(); rafraichirAchat(); });
      if (qtyPlus) qtyPlus.addEventListener('click', () => { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; clampQty(); rafraichirAchat(); });
      qtyInput.addEventListener('input', rafraichirAchat);
      qtyInput.addEventListener('change', () => { clampQty(); rafraichirAchat(); });
      /* ⛔ LE PACK DISPARAÎT DÈS QUE LA QUANTITÉ MONTE — sa règle du 29/08 :
         « la logique voudrait que si tu cliques sur le pack 2 vestes t'aies que
         2 vestes. Si on augmente la quantité, l'offre des 2 vestes n'est plus
         censée apparaître ; dans tous les cas c'est ce qu'on cherche, qu'il
         prenne 2 vestes. Et si la quantité redescend, il faudrait refaire
         apparaître le pack. »
         C'est juste : à quantité 2, proposer un pack de 2 en plus donnerait
         quatre vestes à un client qui en voulait deux — et personne ne saurait
         plus quelle remise couvre quoi.
         ⚠️ Masqué, pas supprimé : il doit revenir intact quand la quantité
           redescend, sans re-rendre la section ni perdre le coloris choisi. */
      const majPack = () => {
        const pack = document.querySelector('.onix-pack2');
        if (!pack) return;
        const q = parseInt(qtyInput.value, 10) || 1;
        pack.hidden = q > 1;
      };
      qtyInput.addEventListener('input', majPack);
      qtyInput.addEventListener('change', majPack);
      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-qty-plus], [data-qty-minus]')) setTimeout(majPack, 30);
      }, true);
      majPack();

      /* Une quantité restaurée par le navigateur au retour arrière ne passe par
         aucun de ces écouteurs : on cale l'état une fois au chargement. */
      poserMultiplicateur();
    }
    };
    window.__onixQuantite();

    const getVariantSizeValue = (variant) => {
      if (!variant || !Array.isArray(variant.options)) return '';
      return variant.options[sizeOptionIndex] || variant.option1 || '';
    };

    const setSelectionState = (hasSelection, variantId = '', variantAvailable = true) => {
      if (variantIdInput) {
        variantIdInput.value = variantId;
      }


      if (submitButton) {
        submitButton.disabled = !hasSelection || !variantAvailable;
        /* Épuisé : la deuxième ligne annoncerait un prix pour un maillot qu'on
           ne peut pas acheter. On la masque plutôt que de la laisser mentir. */
        const ligne2 = submitButton.querySelector('[data-submit-prix]');
        if (ligne2) ligne2.hidden = !variantAvailable;
      }

      /* La barre collante suit le sort du bouton principal : même état, et le
         MÊME libellé, écrit par le même appel. Elle avait ici sa propre source
         (`stickyAddToCartLabel`, le texte SINGULIER capté au chargement), ce
         qui la ramenait au singulier à chaque changement de taille même à
         qté 4 — deuxième moitié du défaut mesuré le 23/08. */
      const collant = document.querySelector('[data-sticky-add]');
      if (collant) collant.disabled = !hasSelection || !variantAvailable;

      /* `poserLabel` vise le span et laisse la flèche tranquille — sans ça elle
         disparaît au premier changement de taille. */
      boutonsAchat().forEach((btn) => {
        poserLabel(btn, variantAvailable ? getAddLabel() : soldOutLabel);
      });
      poserMultiplicateur();
    };

    const setSelectedSizeButton = (selectedSize = '') => {
      sizeButtons().forEach((button) => {
        button.classList.toggle('is-selected', button.dataset.sizeValue === selectedSize);
      });
    };

    const syncVariant = (variantId = '', selectedSize = '', variantAvailable = true) => {
      if (variantId) {
        setSelectedSizeButton(selectedSize);
        setSelectionState(true, String(variantId), variantAvailable);
        return;
      }

      const selectedOption = variantSelect;
      if (selectedOption && selectedOption.value) {
        const matchedVariant = variants.find((variant) => String(variant.id) === String(selectedOption.value));
        setSelectedSizeButton(matchedVariant ? getVariantSizeValue(matchedVariant) : '');
        setSelectionState(true, selectedOption.value, matchedVariant ? matchedVariant.available : true);
        return;
      }

      setSelectedSizeButton('');
      setSelectionState(false, '', false);
    };

    if (variantIdInput && variantIdInput.value) {
      const initialVariant = variants.find((variant) => String(variant.id) === String(variantIdInput.value));
      if (initialVariant) {
        syncVariant(initialVariant.id, getVariantSizeValue(initialVariant), initialVariant.available);
      } else {
        syncVariant();
      }
    } else {
      // Single/default variant: plain input[name="id"] without data-selected-variant-input
      const plainIdInput = mainForm.querySelector('input[name="id"]:not([data-selected-variant-input])');
      if (plainIdInput && plainIdInput.value) {
        const defaultVariant = variants.find((v) => String(v.id) === String(plainIdInput.value));
        setSelectionState(true, plainIdInput.value, defaultVariant ? defaultVariant.available : true);
      } else {
        syncVariant();
      }
    }
    mainForm.addEventListener('change', () => {
      if (variantSelect) {
        syncVariant(variantSelect.value || '', '');
      }
    });

    /* Flocage: drop empty fields from the submission so they don't show up
       as "Nom:", "Numéro:", "Nom sous numéro:" with blank values in the
       cart / checkout summary. Shopify serializes [disabled] inputs as
       absent, so we just disable the empty ones during submit. Non-empty
       fields keep their `disabled` state untouched. We re-enable everything
       in a microtask after submit so the form stays editable if the user
       cancels navigation (e.g. captcha challenge, variant change). */
    mainForm.addEventListener('submit', () => {
      /* ─── LE RETOUR EST IMMÉDIAT, PAS AU RETOUR DU SERVEUR ──────────────
         Entre le clic et l'ouverture du tiroir il s'écoulait ~1,3 s — mesuré
         le 23/08 — pendant lesquelles RIEN ne bougeait. Ses mots : « on est en
         moment d'hésitation, on sait pas si ça va marcher, on sait pas si ça
         n'a pas marché ». Un bouton qui ne répond pas se reclique, et deux
         clics valent deux maillots.
         L'état se pose sur le clic, se retire quand le panier a répondu — et
         un filet le retire de toute façon, pour qu'une requête perdue ne
         laisse jamais un bouton mort. */
      document.querySelectorAll('[data-submit-label], .onix-sticky-cart__button, .onix-product__submit')
        .forEach((b) => b.closest('button, .onix-product__submit')?.classList.add('est-en-cours'));
      const relacher = () => document.querySelectorAll('.est-en-cours')
        .forEach((b) => b.classList.remove('est-en-cours'));
      /* ⚠️ `onix:cart-rendered` N'EXISTE PAS — vérifié le 24/08 par
         scripts/verifier-references.js. Le tiroir n'émet que `cart:refresh`.
         Cet écouteur ne servait à rien ; c'est le second (`cart:refresh`) qui
         relâchait l'état du bouton, et le filet à 6 s qui couvrait le reste.
         Je le retire au lieu de le laisser : un écouteur mort donne l'illusion
         d'une double sécurité là où il n'y en a qu'une. */
      document.addEventListener('cart:refresh', relacher, { once: true });
      setTimeout(relacher, 6000);

      const flocageInputs = mainForm.querySelectorAll('input[name^="properties["]');
      const disabledByUs = [];
      flocageInputs.forEach((input) => {
        const value = (input.value || '').trim();
        if (value === '' && !input.disabled) {
          input.disabled = true;
          disabledByUs.push(input);
        }
      });
      /* Restore after submit tick — keeps the form usable if the page
         doesn't navigate away immediately. */
      setTimeout(() => {
        disabledByUs.forEach((input) => { input.disabled = false; });
      }, 0);
    }, { capture: true });

    if (variantSelect) {
      variantSelect.addEventListener('input', () => {
        syncVariant(variantSelect.value || '', '');
      });
      variantSelect.addEventListener('change', () => {
        syncVariant(variantSelect.value || '', '');
      });
    }

    /* ⛔ LE CÂBLAGE DES TAILLES DOIT SURVIVRE À UN ÉCHANGE DE SECTION — 29/08.
       `sizeButtons` est capturé UNE fois, au chargement du script. Or ce script
       vit dans un bloc {% javascript %}, que Shopify extrait dans un fichier
       chargé une seule fois : il ne se rejoue JAMAIS après un échange de
       section. Résultat, dès qu'on changeait de coloris, les boutons de taille
       du nouveau contenu n'avaient plus aucun écouteur — cliquer une taille ne
       faisait plus rien, sans erreur, sans signal. Le client restait bloqué sur
       la taille présélectionnée.
       ⚠️ C'est le TROISIÈME composant touché par ce même piège cette nuit :
         le pack (résolu par `__onixPack2`), les vidéos (`__onixVids`), et les
         tailles — que j'avais oubliées. Tout ce qui écoute dans cette section
         doit être global, idempotent, et rappelé par `reinitialiser()`.
       ⚠️ Le drapeau sur l'élément, pas une variable : après un échange, les
         boutons sont NEUFS, donc leur drapeau est absent et ils se recâblent.
         Une variable globale, elle, croirait le travail déjà fait. */
    window.__onixTailles = function () {
      /* ⛔ `variants` SE RELIT À CHAQUE APPEL — 29/08, deuxième moitié du bug.
         Recâbler les boutons ne suffisait pas : le tableau `variants` était,
         lui aussi, capturé UNE fois au chargement. Après un échange de section
         vers une AUTRE veste, aucun `data-variant-id` du nouveau contenu ne s'y
         trouvait ; `variants.find(...)` rendait undefined et le code retombait
         sur `syncVariant('', '', false)` — donc aucune sélection, en silence.
         Symptôme exact qu'il décrivait : le bouton prend le focus (contour
         bleu) mais la taille sélectionnée ne bouge pas.
         ⚠️ Le nœud JSON est re-rendu par l'échange : il porte les variantes du
           produit AFFICHÉ. C'est lui la source, pas une copie prise au départ. */
      /* ⛔ TOUTES LES RÉFÉRENCES DE LA SECTION SE RAFRAÎCHISSENT ICI — 29/08.
         Le bug avait QUATRE causes empilées, et chacune paraissait suffisante :
           1. les écouteurs n'étaient pas recâblés après un échange ;
           2. `variants` restait celui du produit initial ;
           3. `sizeButtons` était une NodeList figée sur des boutons détruits ;
           4. `mainForm`, `variantIdInput` et `variantSelect` pointaient eux
              aussi sur l'ancien DOM — d'où une sélection qui bougeait
              visuellement mais un formulaire qui gardait l'ancien identifiant.
         Corriger les trois premières ne changeait RIEN de visible. C'est ce qui
         rend ce défaut si long à cerner : chaque correction juste laisse le
         symptôme intact, et on croit s'être trompé.
         ➜ La règle générale : dans une section échangeable, tout ce qui pointe
           sur le DOM se relit au moment de servir. Une référence gardée est une
           référence périmée. */
      productSection = document.querySelector('.onix-product') || productSection;
      mainForm = (mainFormId ? document.getElementById(mainFormId) : null) || mainForm;
      if (mainForm) {
        submitButton = mainForm.querySelector('[data-product-submit]') || submitButton;
        variantIdInput = mainForm.querySelector('[data-selected-variant-input]') || variantIdInput;
        variantSelect = mainForm.querySelector('select[name="id"]') || variantSelect;
      }
      const noeud = document.querySelector('[data-product-variants-json]');
      if (noeud) {
        try { variants = JSON.parse(noeud.textContent || '[]'); } catch (e) { /* on garde l'ancien */ }
      }
      document.querySelectorAll('[data-size-button]').forEach((button) => {
      if (button.dataset.tailleCablee === '1') return;
      button.dataset.tailleCablee = '1';
      button.addEventListener('click', () => {
        const selectedSize = button.dataset.sizeValue;
        const variantId = button.dataset.variantId || '';
        const variantAvailable = button.dataset.variantAvailable === 'true';
        const matchedVariant = variants.find((variant) => String(variant.id) === String(variantId));

        if (!matchedVariant) {
          syncVariant('', '', false);
          return;
        }

        if (variantSelect) {
          variantSelect.value = String(matchedVariant.id);
          variantSelect.dispatchEvent(new Event('input', { bubbles: true }));
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }

        syncVariant(matchedVariant.id, selectedSize, variantAvailable);
      });
      });
    };
    window.__onixTailles();

  })();

  /* Flèches gallery prev/next — desktop. Scrolle la galerie d'une slide.
     Même raison que les miniatures : fonction globale, rappelée après échange. */
  window.__onixFleches = function () {
    var gallery = document.querySelector('[data-gallery-track]');
    if (gallery && gallery.dataset.flechesCablees === '1') return;
    if (gallery) gallery.dataset.flechesCablees = '1';
    var prev = document.querySelector('[data-gallery-prev]');
    var next = document.querySelector('[data-gallery-next]');
    if (!gallery || (!prev && !next)) return;
    var slides = gallery.querySelectorAll('.onix-product__slide');
    if (slides.length < 2) return;

    function currentIndex() {
      var x = gallery.scrollLeft;
      var closest = 0, dist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - x);
        if (d < dist) { dist = d; closest = i; }
      });
      return closest;
    }
    function go(delta) {
      var i = Math.max(0, Math.min(slides.length - 1, currentIndex() + delta));
      slides[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    }
    function refreshDisabled() {
      var i = currentIndex();
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    var t;
    gallery.addEventListener('scroll', function () {
      clearTimeout(t); t = setTimeout(refreshDisabled, 80);
    }, { passive: true });
    refreshDisabled();
  };

  /* Miniatures — clic pour scroller vers la photo correspondante.
     ⛔ FONCTION GLOBALE, PAS UNE IIFE — 29/08, 17h50. Une IIFE ne s'exécute
       qu'au chargement du fichier ; comme ce script est extrait par Shopify et
       chargé une seule fois, les miniatures du contenu ÉCHANGÉ n'avaient plus
       aucun écouteur. Cliquer la 2ᵉ photo ne faisait rien.
     ⚠️ C'est le CINQUIÈME composant touché par le même piège aujourd'hui. Après
       les tailles, j'ai corrigé ce que je voyais au lieu de recenser TOUT ce qui
       câble des écouteurs dans cette section. Le recensement a pris deux
       minutes ; les corrections une par une en ont pris beaucoup plus. */
  window.__onixMiniatures = function () {
    var thumbs = [].slice.call(document.querySelectorAll('.onix-product__thumb'))
      .filter(function (t) { if (t.dataset.miniCablee === '1') return false; t.dataset.miniCablee = '1'; return true; });
    var gallery = document.querySelector('.onix-product__gallery');
    if (!thumbs.length || !gallery) return;

    var slides = gallery.querySelectorAll('.onix-product__slide');

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = parseInt(thumb.dataset.thumbIndex, 10);
        var target = slides[index];
        if (!target) return;

        /* Scroll la galerie vers la slide cliquée */
        target.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });

        /* Met à jour la classe active */
        thumbs.forEach(function (t) { t.classList.remove('onix-product__thumb--active'); });
        thumb.classList.add('onix-product__thumb--active');
      });
    });

    /* Met à jour la miniature active quand on scroll la galerie manuellement */
    var scrollTimer;
    gallery.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var galleryLeft = gallery.scrollLeft;
        var closest = 0;
        var closestDist = Infinity;
        slides.forEach(function (slide, i) {
          var dist = Math.abs(slide.offsetLeft - galleryLeft);
          if (dist < closestDist) { closestDist = dist; closest = i; }
        });
        thumbs.forEach(function (t) { t.classList.remove('onix-product__thumb--active'); });
        if (thumbs[closest]) thumbs[closest].classList.add('onix-product__thumb--active');
      }, 80);
    }, { passive: true });
  };

  /* Popup avis clients — ouvrir/fermer + focus trap a11y */
  (function () {
    /* ⛔ DÉLÉGATION, ET RÉFÉRENCES RELUES — 29/08. La popup d'avis était câblée
       sur les déclencheurs présents au chargement ; après un changement de
       coloris, la note ne répondait plus. Mesuré : les trois modals de la fiche
       (guide, entretien, avis) marchaient avant l'échange, aucun après.
       Une IIFE qui capture ses nœuds une fois ne survit pas à un remplacement de
       section — c'est le même piège que les six autres composants de cette page,
       et c'est la dernière occurrence connue. */
    var popup = document.querySelector('[data-reviews-popup]');
    var panel = popup ? popup.querySelector('.onix-product__reviews-popup-panel') : null;
    var relire = function () {
      popup = document.querySelector('[data-reviews-popup]') || popup;
      panel = popup ? (popup.querySelector('.onix-product__reviews-popup-panel') || panel) : panel;
    };
    if (!popup || !panel) return;

    /* Remember which element had focus before the popup opened, so we
       can restore it when the popup closes (a11y best practice). */
    var _lastFocused = null;

    /* Focus-trap: confine Tab navigation inside the panel while open. */
    function getFocusables() {
      return panel.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function onTabTrap(e) {
      if (e.key !== 'Tab') return;
      var focusables = getFocusables();
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    function openPopup() {
      _lastFocused = document.activeElement;
      popup.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      /* Move focus to the close button so keyboard users land there. */
      var closeBtn = panel.querySelector('.onix-product__reviews-popup-close');
      if (closeBtn) closeBtn.focus();
      panel.addEventListener('keydown', onTabTrap);
    }

    function closePopup() {
      popup.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      panel.removeEventListener('keydown', onTabTrap);
      /* Return focus to the element that opened the popup. */
      if (_lastFocused && typeof _lastFocused.focus === 'function') {
        try { _lastFocused.focus(); } catch (err) { /* element gone from DOM */ }
      }
      _lastFocused = null;
    }

    /* Un seul écouteur sur le document, qui survit à tous les remplacements. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      if (e.target.closest('[data-reviews-popup-trigger]')) { relire(); openPopup(e); return; }
      if (e.target.closest('[data-reviews-popup-close]')) { relire(); closePopup(e); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.getAttribute('aria-hidden') === 'false') closePopup();
    });
  })();


  /* ⚠️ LE CALCUL DE LIVRAISON A DÉMÉNAGÉ dans assets/onix-livraison.js — 23/08.
     Il a demandé la même prévision dans le tiroir de panier ; le dupliquer
     aurait garanti qu'un jour les deux divergent. Le fichier est chargé en
     tête de cette section et cible tous les `[data-livraison]` de la page. */

  /* ── Livraison estimée : date du jour + min/max jours, formatée par langue.
     Se recalcule à chaque chargement → toujours à jour, jamais codée en dur. ── */
  (function () {
    var nodes = document.querySelectorAll('[data-delivery-estimate]');
    if (!nodes.length) return;
    var locale = (document.documentElement.lang || 'fr').slice(0, 2);
    function fmt(d, dayOnly) {
      try {
        return new Intl.DateTimeFormat(locale, dayOnly ? { day: 'numeric' } : { day: 'numeric', month: 'long' }).format(d);
      } catch (e) {
        return d.getDate() + '/' + (d.getMonth() + 1);
      }
    }
    function skipSunday(d) { if (d.getDay() === 0) { d.setDate(d.getDate() + 1); } return d; }
    nodes.forEach(function (el) {
      var min = parseInt(el.getAttribute('data-delivery-min'), 10) || 13;
      var max = parseInt(el.getAttribute('data-delivery-max'), 10) || 15;
      var from = new Date(); from.setDate(from.getDate() + min); skipSunday(from);
      var to = new Date(); to.setDate(to.getDate() + max); skipSunday(to);
      /* Même mois (hors anglais qui met le mois avant le jour) → on n'affiche
         le mois qu'une fois : « entre le 5 et le 6 juillet ». */
      var sameMonth = from.getMonth() === to.getMonth() && from.getFullYear() === to.getFullYear();
      var fromStr = (sameMonth && locale !== 'en') ? fmt(from, true) : fmt(from, false);
      var toStr = fmt(to, false);
      var tpl = el.getAttribute('data-delivery-tpl') || 'Livraison estimée entre le %from% et le %to%';
      var span = el.querySelector('[data-delivery-text]');
      /* fromStr/toStr viennent d'Intl + tpl d'une clé i18n → sources sûres,
         innerHTML OK ; met les dates en gras pour qu'elles ressortent. */
      if (span) span.innerHTML = tpl.replace('%from%', '<strong>' + fromStr + '</strong>').replace('%to%', '<strong>' + toStr + '</strong>');
    });
  })();

  /* ── Récemment vus : enregistre le produit courant dans localStorage et
     rend les précédents en mini-cartes (fetch /products/{handle}.js —
     prix dans la devise du marché actif, formaté comme le bundle). ── */
  (() => {
    const box = document.querySelector('[data-rv]');
    if (!box || !box.dataset.current) return;
    const KEY = 'onix_rv';
    const cur = box.dataset.current;
    let list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (_) {}
    if (!Array.isArray(list)) list = [];
    const others = list.filter((h) => typeof h === 'string' && h && h !== cur).slice(0, 8);
    try { localStorage.setItem(KEY, JSON.stringify([cur].concat(others).slice(0, 12))); } catch (_) {}
    if (!others.length) return;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const fmt = (cents) => {
      const cur2 = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      if (cur2 === 'EUR') return (cents / 100).toFixed(2).replace('.', ',') + '€';
      try { return new Intl.NumberFormat('en', { style: 'currency', currency: cur2, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
      catch (_) { return (cents / 100).toFixed(2) + ' ' + cur2; }
    };
    Promise.all(others.map((h) => fetch(root + 'products/' + h + '.js').then((r) => (r.ok ? r.json() : null)).catch(() => null)))
      .then((prods) => {
        const row = box.querySelector('[data-rv-row]');
        if (!row) return;
        let shown = 0;
        prods.filter(Boolean).forEach((p) => {
          if (!p.available || !p.handle) return;
          const a = document.createElement('a');
          a.className = 'onix-rv__card';
          a.href = root + 'products/' + p.handle;
          const img = document.createElement('img');
          img.className = 'onix-rv__img';
          img.loading = 'lazy';
          if (p.featured_image) img.src = p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=300';
          img.alt = p.title;
          const nm = document.createElement('span');
          nm.className = 'onix-rv__name';
          const parts = p.title.split(/\s[–-]\s/);
          nm.textContent = parts.length > 1 ? parts.slice(0, -1).join(' – ') : p.title;
          const pr = document.createElement('span');
          pr.className = 'onix-rv__price';
          pr.textContent = fmt(p.price);
          a.append(img, nm, pr);
          row.appendChild(a);
          shown++;
        });
        if (shown) box.hidden = false;
      });
  })();

  /* Premier câblage des composants définis plus haut. Ils sont ensuite rappelés
     par `rejouerTout()` après chaque échange de section. */
  if (typeof window.__onixMiniatures === 'function') window.__onixMiniatures();
  if (typeof window.__onixFleches === 'function') window.__onixFleches();


  } catch(e) { console.error(e); }
})();
})();
